/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface EmployeesService {
  /** @summary Me */
  meEmployeesMeGet: {
    /** @summary Me */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<MeEmployeesMeGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: MeEmployeesMeGetSchema,
        options: {
          parameters: MeEmployeesMeGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<MeEmployeesMeGetData, MeEmployeesMeGetError>>
    ): Promise<RequestFnResponse<MeEmployeesMeGetData, MeEmployeesMeGetError>>;
    /** @summary Me */
    getQueryKey(
      parameters: DeepReadonly<MeEmployeesMeGetParameters> | void
    ): ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Me
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.meEmployeesMeGet.useQuery()
     * ```
     */
    useQuery<TData = MeEmployeesMeGetData>(
      parameters:
        | ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | (DeepReadonly<MeEmployeesMeGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          MeEmployeesMeGetData,
          MeEmployeesMeGetError,
          TData,
          ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<MeEmployeesMeGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Me
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.meEmployeesMeGet.useQuery()
     * ```
     */
    useQuery<TData = MeEmployeesMeGetData>(
      parameters:
        | ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | (DeepReadonly<MeEmployeesMeGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          MeEmployeesMeGetData,
          MeEmployeesMeGetError,
          TData,
          ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<MeEmployeesMeGetError>>;
    /** @summary Me */
    getInfiniteQueryKey(
      parameters: DeepReadonly<MeEmployeesMeGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Me
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.meEmployeesMeGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends MeEmployeesMeGetParameters,
      TQueryFnData = MeEmployeesMeGetData,
      TData = OperationInfiniteData<TQueryFnData, MeEmployeesMeGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | (DeepReadonly<MeEmployeesMeGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          MeEmployeesMeGetError,
          TData,
          ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<MeEmployeesMeGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Me
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.meEmployeesMeGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends MeEmployeesMeGetParameters,
      TQueryFnData = MeEmployeesMeGetData,
      TData = OperationInfiniteData<TQueryFnData, MeEmployeesMeGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | (DeepReadonly<MeEmployeesMeGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          MeEmployeesMeGetError,
          TData,
          ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<MeEmployeesMeGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<MeEmployeesMeGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Me
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const meEmployeesMeGetTotal = qraft.employeesService.meEmployeesMeGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
        | QueryFiltersByQueryKey<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Me
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const meEmployeesMeGetResults = qraft.employeesService.meEmployeesMeGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * meEmployeesMeGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const meEmployeesMeGetCombinedResults = qraft.employeesService.meEmployeesMeGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * meEmployeesMeGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          MeEmployeesMeGetSchema,
          MeEmployeesMeGetParameters,
          MeEmployeesMeGetData,
          MeEmployeesMeGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<MeEmployeesMeGetData, MeEmployeesMeGetError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<MeEmployeesMeGetData, MeEmployeesMeGetError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Me
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.employeesService.meEmployeesMeGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = MeEmployeesMeGetData>(
      parameters:
        | ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | (DeepReadonly<MeEmployeesMeGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          MeEmployeesMeGetData,
          MeEmployeesMeGetError,
          TData,
          ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<MeEmployeesMeGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Me
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.meEmployeesMeGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends MeEmployeesMeGetParameters, TData = MeEmployeesMeGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | (DeepReadonly<MeEmployeesMeGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          MeEmployeesMeGetData,
          MeEmployeesMeGetError,
          OperationInfiniteData<TData, MeEmployeesMeGetParameters>,
          ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<MeEmployeesMeGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, MeEmployeesMeGetParameters>,
      OperationError<MeEmployeesMeGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Me
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const meEmployeesMeGetData = qraft.employeesService.meEmployeesMeGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * meEmployeesMeGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const meEmployeesMeGetCombinedData = qraft.employeesService.meEmployeesMeGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * meEmployeesMeGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          MeEmployeesMeGetSchema,
          MeEmployeesMeGetParameters,
          MeEmployeesMeGetData,
          MeEmployeesMeGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<MeEmployeesMeGetData, MeEmployeesMeGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<MeEmployeesMeGetData, MeEmployeesMeGetError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Me */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        MeEmployeesMeGetSchema,
        MeEmployeesMeGetData,
        MeEmployeesMeGetParameters,
        MeEmployeesMeGetError
      > | void
    ): Promise<MeEmployeesMeGetData>;
    /** @summary Me */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        MeEmployeesMeGetSchema,
        MeEmployeesMeGetData,
        MeEmployeesMeGetParameters,
        MeEmployeesMeGetError
      > | void
    ): Promise<void>;
    /** @summary Me */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        MeEmployeesMeGetSchema,
        MeEmployeesMeGetData,
        MeEmployeesMeGetParameters,
        MeEmployeesMeGetError
      > | void
    ): Promise<MeEmployeesMeGetData>;
    /** @summary Me */
    fetchInfiniteQuery<TPageParam extends MeEmployeesMeGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        MeEmployeesMeGetSchema,
        MeEmployeesMeGetData,
        MeEmployeesMeGetParameters,
        DeepReadonly<TPageParam>,
        MeEmployeesMeGetError
      > | void
    ): Promise<OperationInfiniteData<MeEmployeesMeGetData, MeEmployeesMeGetParameters>>;
    /** @summary Me */
    prefetchInfiniteQuery<TPageParam extends MeEmployeesMeGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        MeEmployeesMeGetSchema,
        MeEmployeesMeGetData,
        MeEmployeesMeGetParameters,
        DeepReadonly<TPageParam>,
        MeEmployeesMeGetError
      > | void
    ): Promise<void>;
    /** @summary Me */
    ensureInfiniteQueryData<TPageParam extends MeEmployeesMeGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        MeEmployeesMeGetSchema,
        MeEmployeesMeGetData,
        MeEmployeesMeGetParameters,
        DeepReadonly<TPageParam>,
        MeEmployeesMeGetError
      > | void
    ): Promise<OperationInfiniteData<MeEmployeesMeGetData, MeEmployeesMeGetParameters>>;
    /** @summary Me */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | (DeepReadonly<MeEmployeesMeGetParameters> | void)
    ): MeEmployeesMeGetData | undefined;
    /** @summary Me */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | (DeepReadonly<MeEmployeesMeGetParameters> | void)
    ): OperationInfiniteData<MeEmployeesMeGetData, MeEmployeesMeGetParameters> | undefined;
    /** @summary Me */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
        | QueryFiltersByQueryKey<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>,
            data: NoInfer<OperationInfiniteData<MeEmployeesMeGetData, MeEmployeesMeGetParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>,
            data: MeEmployeesMeGetData | undefined,
          ]
        >;
    /** @summary Me */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | (DeepReadonly<MeEmployeesMeGetParameters> | void)
    ): QueryState<MeEmployeesMeGetData, MeEmployeesMeGetError> | undefined;
    /** @summary Me */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<MeEmployeesMeGetParameters>
        | ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<MeEmployeesMeGetData, MeEmployeesMeGetParameters>, MeEmployeesMeGetError>
      | undefined;
    /** @summary Me */
    setQueryData(
      parameters:
        | (DeepReadonly<MeEmployeesMeGetParameters> | undefined)
        | ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>,
      updater: Updater<
        NoInfer<MeEmployeesMeGetData> | undefined,
        NoInfer<DeepReadonly<MeEmployeesMeGetData>> | undefined
      >,
      options?: SetDataOptions
    ): MeEmployeesMeGetData | undefined;
    /** @summary Me */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<MeEmployeesMeGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<MeEmployeesMeGetData, MeEmployeesMeGetParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<MeEmployeesMeGetData, MeEmployeesMeGetParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<MeEmployeesMeGetData, MeEmployeesMeGetParameters> | undefined;
    /** @summary Me */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
        | QueryFiltersByQueryKey<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >,
      updater: Updater<NoInfer<MeEmployeesMeGetData> | undefined, NoInfer<MeEmployeesMeGetData> | undefined>,
      options?: SetDataOptions
    ): Array<MeEmployeesMeGetData | undefined>;
    /** @summary Me */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        MeEmployeesMeGetSchema,
        MeEmployeesMeGetData,
        TInfinite,
        MeEmployeesMeGetParameters,
        MeEmployeesMeGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Me */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
        | QueryFiltersByQueryKey<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Me */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
        | QueryFiltersByQueryKey<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Me */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
        | QueryFiltersByQueryKey<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
    ): void;
    /** @summary Me */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
        | QueryFiltersByQueryKey<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Me */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
        | QueryFiltersByQueryKey<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
    ): number;
    schema: MeEmployeesMeGetSchema;
    types: {
      parameters: MeEmployeesMeGetParameters;
      data: MeEmployeesMeGetData;
      error: MeEmployeesMeGetError;
    };
  };
  /** @summary Me Options */
  meOptions: {
    /** @summary Me Options */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<MeOptionsSchema, MeOptionsParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<MeOptionsParameters, TMeta, TSignal> | void),
      client?: (
        schema: MeOptionsSchema,
        options: {
          parameters: MeOptionsParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<MeOptionsData, MeOptionsError>>
    ): Promise<RequestFnResponse<MeOptionsData, MeOptionsError>>;
    /** @summary Me Options */
    getQueryKey(
      parameters: DeepReadonly<MeOptionsParameters> | void
    ): ServiceOperationQueryKey<MeOptionsSchema, MeOptionsParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Me Options
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.meOptions.useQuery()
     * ```
     */
    useQuery<TData = MeOptionsData>(
      parameters:
        | ServiceOperationQueryKey<MeOptionsSchema, MeOptionsParameters>
        | (DeepReadonly<MeOptionsParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          MeOptionsData,
          MeOptionsError,
          TData,
          ServiceOperationQueryKey<MeOptionsSchema, MeOptionsParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<MeOptionsError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Me Options
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.meOptions.useQuery()
     * ```
     */
    useQuery<TData = MeOptionsData>(
      parameters:
        | ServiceOperationQueryKey<MeOptionsSchema, MeOptionsParameters>
        | (DeepReadonly<MeOptionsParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          MeOptionsData,
          MeOptionsError,
          TData,
          ServiceOperationQueryKey<MeOptionsSchema, MeOptionsParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<MeOptionsError>>;
    /** @summary Me Options */
    getInfiniteQueryKey(
      parameters: DeepReadonly<MeOptionsParameters> | void
    ): ServiceOperationInfiniteQueryKey<MeOptionsSchema, MeOptionsParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Me Options
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.meOptions.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends MeOptionsParameters,
      TQueryFnData = MeOptionsData,
      TData = OperationInfiniteData<TQueryFnData, MeOptionsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<MeOptionsSchema, MeOptionsParameters>
        | (DeepReadonly<MeOptionsParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          MeOptionsError,
          TData,
          ServiceOperationInfiniteQueryKey<MeOptionsSchema, MeOptionsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<MeOptionsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Me Options
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.meOptions.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends MeOptionsParameters,
      TQueryFnData = MeOptionsData,
      TData = OperationInfiniteData<TQueryFnData, MeOptionsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<MeOptionsSchema, MeOptionsParameters>
        | (DeepReadonly<MeOptionsParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          MeOptionsError,
          TData,
          ServiceOperationInfiniteQueryKey<MeOptionsSchema, MeOptionsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<MeOptionsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<MeOptionsError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Me Options
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const meOptionsTotal = qraft.employeesService.meOptions.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<MeOptionsSchema, MeOptionsData, TInfinite, MeOptionsParameters, MeOptionsError>
        | QueryFiltersByQueryKey<MeOptionsSchema, MeOptionsData, TInfinite, MeOptionsParameters, MeOptionsError>
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Me Options
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const meOptionsResults = qraft.employeesService.meOptions.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * meOptionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const meOptionsCombinedResults = qraft.employeesService.meOptions.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * meOptionsCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<MeOptionsSchema, MeOptionsParameters, MeOptionsData, MeOptionsError>
      >,
      TCombinedResult = Array<UseQueryResult<MeOptionsData, MeOptionsError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<MeOptionsData, MeOptionsError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Me Options
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.employeesService.meOptions.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = MeOptionsData>(
      parameters:
        | ServiceOperationQueryKey<MeOptionsSchema, MeOptionsParameters>
        | (DeepReadonly<MeOptionsParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          MeOptionsData,
          MeOptionsError,
          TData,
          ServiceOperationQueryKey<MeOptionsSchema, MeOptionsParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<MeOptionsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Me Options
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.meOptions.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends MeOptionsParameters, TData = MeOptionsData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<MeOptionsSchema, MeOptionsParameters>
        | (DeepReadonly<MeOptionsParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          MeOptionsData,
          MeOptionsError,
          OperationInfiniteData<TData, MeOptionsParameters>,
          ServiceOperationInfiniteQueryKey<MeOptionsSchema, MeOptionsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<MeOptionsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, MeOptionsParameters>,
      OperationError<MeOptionsError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Me Options
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const meOptionsData = qraft.employeesService.meOptions.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * meOptionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const meOptionsCombinedData = qraft.employeesService.meOptions.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * meOptionsCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<MeOptionsSchema, MeOptionsParameters, MeOptionsData, MeOptionsError>
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<MeOptionsData, MeOptionsError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<MeOptionsData, MeOptionsError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Me Options */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        MeOptionsSchema,
        MeOptionsData,
        MeOptionsParameters,
        MeOptionsError
      > | void
    ): Promise<MeOptionsData>;
    /** @summary Me Options */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        MeOptionsSchema,
        MeOptionsData,
        MeOptionsParameters,
        MeOptionsError
      > | void
    ): Promise<void>;
    /** @summary Me Options */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        MeOptionsSchema,
        MeOptionsData,
        MeOptionsParameters,
        MeOptionsError
      > | void
    ): Promise<MeOptionsData>;
    /** @summary Me Options */
    fetchInfiniteQuery<TPageParam extends MeOptionsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        MeOptionsSchema,
        MeOptionsData,
        MeOptionsParameters,
        DeepReadonly<TPageParam>,
        MeOptionsError
      > | void
    ): Promise<OperationInfiniteData<MeOptionsData, MeOptionsParameters>>;
    /** @summary Me Options */
    prefetchInfiniteQuery<TPageParam extends MeOptionsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        MeOptionsSchema,
        MeOptionsData,
        MeOptionsParameters,
        DeepReadonly<TPageParam>,
        MeOptionsError
      > | void
    ): Promise<void>;
    /** @summary Me Options */
    ensureInfiniteQueryData<TPageParam extends MeOptionsParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        MeOptionsSchema,
        MeOptionsData,
        MeOptionsParameters,
        DeepReadonly<TPageParam>,
        MeOptionsError
      > | void
    ): Promise<OperationInfiniteData<MeOptionsData, MeOptionsParameters>>;
    /** @summary Me Options */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<MeOptionsSchema, MeOptionsParameters>
        | (DeepReadonly<MeOptionsParameters> | void)
    ): MeOptionsData | undefined;
    /** @summary Me Options */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<MeOptionsSchema, MeOptionsParameters>
        | (DeepReadonly<MeOptionsParameters> | void)
    ): OperationInfiniteData<MeOptionsData, MeOptionsParameters> | undefined;
    /** @summary Me Options */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<MeOptionsSchema, MeOptionsData, TInfinite, MeOptionsParameters, MeOptionsError>
        | QueryFiltersByQueryKey<MeOptionsSchema, MeOptionsData, TInfinite, MeOptionsParameters, MeOptionsError>
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<MeOptionsSchema, MeOptionsParameters>,
            data: NoInfer<OperationInfiniteData<MeOptionsData, MeOptionsParameters>> | undefined,
          ]
        >
      : Array<
          [queryKey: ServiceOperationQueryKey<MeOptionsSchema, MeOptionsParameters>, data: MeOptionsData | undefined]
        >;
    /** @summary Me Options */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<MeOptionsSchema, MeOptionsParameters>
        | (DeepReadonly<MeOptionsParameters> | void)
    ): QueryState<MeOptionsData, MeOptionsError> | undefined;
    /** @summary Me Options */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<MeOptionsParameters>
        | ServiceOperationInfiniteQueryKey<MeOptionsSchema, MeOptionsParameters>
        | void
    ): QueryState<OperationInfiniteData<MeOptionsData, MeOptionsParameters>, MeOptionsError> | undefined;
    /** @summary Me Options */
    setQueryData(
      parameters:
        | (DeepReadonly<MeOptionsParameters> | undefined)
        | ServiceOperationQueryKey<MeOptionsSchema, MeOptionsParameters>,
      updater: Updater<NoInfer<MeOptionsData> | undefined, NoInfer<DeepReadonly<MeOptionsData>> | undefined>,
      options?: SetDataOptions
    ): MeOptionsData | undefined;
    /** @summary Me Options */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<MeOptionsParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<MeOptionsSchema, MeOptionsParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<MeOptionsData, MeOptionsParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<MeOptionsData, MeOptionsParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<MeOptionsData, MeOptionsParameters> | undefined;
    /** @summary Me Options */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<MeOptionsSchema, MeOptionsData, TInfinite, MeOptionsParameters, MeOptionsError>
        | QueryFiltersByQueryKey<MeOptionsSchema, MeOptionsData, TInfinite, MeOptionsParameters, MeOptionsError>,
      updater: Updater<NoInfer<MeOptionsData> | undefined, NoInfer<MeOptionsData> | undefined>,
      options?: SetDataOptions
    ): Array<MeOptionsData | undefined>;
    /** @summary Me Options */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<MeOptionsSchema, MeOptionsData, TInfinite, MeOptionsParameters, MeOptionsError>,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Me Options */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<MeOptionsSchema, MeOptionsData, TInfinite, MeOptionsParameters, MeOptionsError>
        | QueryFiltersByQueryKey<MeOptionsSchema, MeOptionsData, TInfinite, MeOptionsParameters, MeOptionsError>,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Me Options */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<MeOptionsSchema, MeOptionsData, TInfinite, MeOptionsParameters, MeOptionsError>
        | QueryFiltersByQueryKey<MeOptionsSchema, MeOptionsData, TInfinite, MeOptionsParameters, MeOptionsError>,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Me Options */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<MeOptionsSchema, MeOptionsData, TInfinite, MeOptionsParameters, MeOptionsError>
        | QueryFiltersByQueryKey<MeOptionsSchema, MeOptionsData, TInfinite, MeOptionsParameters, MeOptionsError>
    ): void;
    /** @summary Me Options */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<MeOptionsSchema, MeOptionsData, TInfinite, MeOptionsParameters, MeOptionsError>
        | QueryFiltersByQueryKey<MeOptionsSchema, MeOptionsData, TInfinite, MeOptionsParameters, MeOptionsError>,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Me Options */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<MeOptionsSchema, MeOptionsData, TInfinite, MeOptionsParameters, MeOptionsError>
        | QueryFiltersByQueryKey<MeOptionsSchema, MeOptionsData, TInfinite, MeOptionsParameters, MeOptionsError>
    ): number;
    schema: MeOptionsSchema;
    types: {
      parameters: MeOptionsParameters;
      data: MeOptionsData;
      error: MeOptionsError;
    };
  };
  /** @summary Get All */
  getAllEmployeesGet: {
    /** @summary Get All */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<GetAllEmployeesGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetAllEmployeesGetSchema,
        options: {
          parameters: GetAllEmployeesGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAllEmployeesGetData, GetAllEmployeesGetError>>
    ): Promise<RequestFnResponse<GetAllEmployeesGetData, GetAllEmployeesGetError>>;
    /** @summary Get All */
    getQueryKey(
      parameters: DeepReadonly<GetAllEmployeesGetParameters> | void
    ): ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.getAllEmployeesGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllEmployeesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | (DeepReadonly<GetAllEmployeesGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllEmployeesGetData,
          GetAllEmployeesGetError,
          TData,
          ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllEmployeesGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.getAllEmployeesGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllEmployeesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | (DeepReadonly<GetAllEmployeesGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetAllEmployeesGetData,
          GetAllEmployeesGetError,
          TData,
          ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllEmployeesGetError>>;
    /** @summary Get All */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllEmployeesGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.getAllEmployeesGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllEmployeesGetParameters,
      TQueryFnData = GetAllEmployeesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllEmployeesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | (DeepReadonly<GetAllEmployeesGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllEmployeesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllEmployeesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.getAllEmployeesGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllEmployeesGetParameters,
      TQueryFnData = GetAllEmployeesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllEmployeesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | (DeepReadonly<GetAllEmployeesGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllEmployeesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllEmployeesGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllEmployeesGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllEmployeesGetTotal = qraft.employeesService.getAllEmployeesGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllEmployeesGetResults = qraft.employeesService.getAllEmployeesGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllEmployeesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllEmployeesGetCombinedResults = qraft.employeesService.getAllEmployeesGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllEmployeesGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllEmployeesGetSchema,
          GetAllEmployeesGetParameters,
          GetAllEmployeesGetData,
          GetAllEmployeesGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetAllEmployeesGetData, GetAllEmployeesGetError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetAllEmployeesGetData, GetAllEmployeesGetError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.employeesService.getAllEmployeesGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetAllEmployeesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | (DeepReadonly<GetAllEmployeesGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllEmployeesGetData,
          GetAllEmployeesGetError,
          TData,
          ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllEmployeesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.getAllEmployeesGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetAllEmployeesGetParameters, TData = GetAllEmployeesGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | (DeepReadonly<GetAllEmployeesGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllEmployeesGetData,
          GetAllEmployeesGetError,
          OperationInfiniteData<TData, GetAllEmployeesGetParameters>,
          ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllEmployeesGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllEmployeesGetParameters>,
      OperationError<GetAllEmployeesGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllEmployeesGetData = qraft.employeesService.getAllEmployeesGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllEmployeesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllEmployeesGetCombinedData = qraft.employeesService.getAllEmployeesGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllEmployeesGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllEmployeesGetSchema,
          GetAllEmployeesGetParameters,
          GetAllEmployeesGetData,
          GetAllEmployeesGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetAllEmployeesGetData, GetAllEmployeesGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetAllEmployeesGetData, GetAllEmployeesGetError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get All */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllEmployeesGetSchema,
        GetAllEmployeesGetData,
        GetAllEmployeesGetParameters,
        GetAllEmployeesGetError
      > | void
    ): Promise<GetAllEmployeesGetData>;
    /** @summary Get All */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllEmployeesGetSchema,
        GetAllEmployeesGetData,
        GetAllEmployeesGetParameters,
        GetAllEmployeesGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllEmployeesGetSchema,
        GetAllEmployeesGetData,
        GetAllEmployeesGetParameters,
        GetAllEmployeesGetError
      > | void
    ): Promise<GetAllEmployeesGetData>;
    /** @summary Get All */
    fetchInfiniteQuery<TPageParam extends GetAllEmployeesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllEmployeesGetSchema,
        GetAllEmployeesGetData,
        GetAllEmployeesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllEmployeesGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllEmployeesGetData, GetAllEmployeesGetParameters>>;
    /** @summary Get All */
    prefetchInfiniteQuery<TPageParam extends GetAllEmployeesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllEmployeesGetSchema,
        GetAllEmployeesGetData,
        GetAllEmployeesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllEmployeesGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureInfiniteQueryData<TPageParam extends GetAllEmployeesGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllEmployeesGetSchema,
        GetAllEmployeesGetData,
        GetAllEmployeesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllEmployeesGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllEmployeesGetData, GetAllEmployeesGetParameters>>;
    /** @summary Get All */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | (DeepReadonly<GetAllEmployeesGetParameters> | void)
    ): GetAllEmployeesGetData | undefined;
    /** @summary Get All */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | (DeepReadonly<GetAllEmployeesGetParameters> | void)
    ): OperationInfiniteData<GetAllEmployeesGetData, GetAllEmployeesGetParameters> | undefined;
    /** @summary Get All */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>,
            data: NoInfer<OperationInfiniteData<GetAllEmployeesGetData, GetAllEmployeesGetParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>,
            data: GetAllEmployeesGetData | undefined,
          ]
        >;
    /** @summary Get All */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | (DeepReadonly<GetAllEmployeesGetParameters> | void)
    ): QueryState<GetAllEmployeesGetData, GetAllEmployeesGetError> | undefined;
    /** @summary Get All */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllEmployeesGetParameters>
        | ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<GetAllEmployeesGetData, GetAllEmployeesGetParameters>, GetAllEmployeesGetError>
      | undefined;
    /** @summary Get All */
    setQueryData(
      parameters:
        | (DeepReadonly<GetAllEmployeesGetParameters> | undefined)
        | ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>,
      updater: Updater<
        NoInfer<GetAllEmployeesGetData> | undefined,
        NoInfer<DeepReadonly<GetAllEmployeesGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAllEmployeesGetData | undefined;
    /** @summary Get All */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetAllEmployeesGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetAllEmployeesGetData, GetAllEmployeesGetParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetAllEmployeesGetData, GetAllEmployeesGetParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetAllEmployeesGetData, GetAllEmployeesGetParameters> | undefined;
    /** @summary Get All */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >,
      updater: Updater<NoInfer<GetAllEmployeesGetData> | undefined, NoInfer<GetAllEmployeesGetData> | undefined>,
      options?: SetDataOptions
    ): Array<GetAllEmployeesGetData | undefined>;
    /** @summary Get All */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllEmployeesGetSchema,
        GetAllEmployeesGetData,
        TInfinite,
        GetAllEmployeesGetParameters,
        GetAllEmployeesGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get All */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get All */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get All */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
    ): void;
    /** @summary Get All */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get All */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
    ): number;
    schema: GetAllEmployeesGetSchema;
    types: {
      parameters: GetAllEmployeesGetParameters;
      data: GetAllEmployeesGetData;
      error: GetAllEmployeesGetError;
    };
  };
  /** @summary Create */
  createEmployeesPost: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateEmployeesPostBody,
        CreateEmployeesPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateEmployeesPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateEmployeesPostBody,
          CreateEmployeesPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<CreateEmployeesPostData, CreateEmployeesPostError>>
    ): Promise<RequestFnResponse<CreateEmployeesPostData, CreateEmployeesPostError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateEmployeesPostParameters> | void
    ): ServiceOperationMutationKey<CreateEmployeesPostSchema, CreateEmployeesPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.createEmployeesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.createEmployeesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateEmployeesPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateEmployeesPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateEmployeesPostSchema,
        CreateEmployeesPostData,
        CreateEmployeesPostParameters,
        TVariables,
        OperationError<CreateEmployeesPostError>,
        TContext
      >
    ): UseMutationResult<CreateEmployeesPostData, OperationError<CreateEmployeesPostError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.createEmployeesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.createEmployeesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateEmployeesPostBody, CreateEmployeesPostParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateEmployeesPostSchema,
        CreateEmployeesPostData,
        CreateEmployeesPostParameters,
        TVariables,
        OperationError<CreateEmployeesPostError>,
        TContext
      >
    ): UseMutationResult<CreateEmployeesPostData, OperationError<CreateEmployeesPostError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createEmployeesPostTotal = qraft.employeesService.createEmployeesPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createEmployeesPostTotal = qraft.employeesService.createEmployeesPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateEmployeesPostBody,
            CreateEmployeesPostData,
            CreateEmployeesPostParameters,
            OperationError<CreateEmployeesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateEmployeesPostSchema,
            CreateEmployeesPostBody,
            CreateEmployeesPostData,
            CreateEmployeesPostParameters,
            OperationError<CreateEmployeesPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createEmployeesPostPendingMutationVariables = qraft.employeesService.createEmployeesPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createEmployeesPostMutationData = qraft.employeesService.createEmployeesPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateEmployeesPostData,
        OperationError<CreateEmployeesPostError>,
        MutationVariables<CreateEmployeesPostBody, CreateEmployeesPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateEmployeesPostBody,
            CreateEmployeesPostData,
            CreateEmployeesPostParameters,
            OperationError<CreateEmployeesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateEmployeesPostSchema,
            CreateEmployeesPostBody,
            CreateEmployeesPostData,
            CreateEmployeesPostParameters,
            OperationError<CreateEmployeesPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateEmployeesPostData,
          OperationError<CreateEmployeesPostError>,
          MutationVariables<CreateEmployeesPostBody, CreateEmployeesPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateEmployeesPostBody,
            CreateEmployeesPostData,
            CreateEmployeesPostParameters,
            OperationError<CreateEmployeesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateEmployeesPostSchema,
            CreateEmployeesPostBody,
            CreateEmployeesPostData,
            CreateEmployeesPostParameters,
            OperationError<CreateEmployeesPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeesService.createEmployeesPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeesService.createEmployeesPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateEmployeesPostBody,
              CreateEmployeesPostData,
              CreateEmployeesPostParameters,
              OperationError<CreateEmployeesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateEmployeesPostSchema,
              CreateEmployeesPostBody,
              CreateEmployeesPostData,
              CreateEmployeesPostParameters,
              OperationError<CreateEmployeesPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateEmployeesPostData,
            CreateEmployeesPostError,
            MutationVariables<CreateEmployeesPostBody, CreateEmployeesPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateEmployeesPostBody,
              CreateEmployeesPostData,
              CreateEmployeesPostParameters,
              OperationError<CreateEmployeesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateEmployeesPostSchema,
              CreateEmployeesPostBody,
              CreateEmployeesPostData,
              CreateEmployeesPostParameters,
              OperationError<CreateEmployeesPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateEmployeesPostData,
          CreateEmployeesPostError,
          MutationVariables<CreateEmployeesPostBody, CreateEmployeesPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateEmployeesPostSchema;
    types: {
      parameters: CreateEmployeesPostParameters;
      data: CreateEmployeesPostData;
      error: CreateEmployeesPostError;
      body: CreateEmployeesPostBody;
    };
  };
  /**
   * @summary Search Employees
   * @description Search employees with pagination and optional filters.
   */
  searchEmployees: {
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<SearchEmployeesSchema, SearchEmployeesParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<SearchEmployeesParameters, TMeta, TSignal> | void),
      client?: (
        schema: SearchEmployeesSchema,
        options: {
          parameters: SearchEmployeesParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<SearchEmployeesData, SearchEmployeesError>>
    ): Promise<RequestFnResponse<SearchEmployeesData, SearchEmployeesError>>;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    getQueryKey(
      parameters: DeepReadonly<SearchEmployeesParameters> | void
    ): ServiceOperationQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.searchEmployees.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.searchEmployees.useQuery({
     *     query: {
     *         page: page
     *     }
     * })
     * ```
     */
    useQuery<TData = SearchEmployeesData>(
      parameters:
        | ServiceOperationQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>
        | (DeepReadonly<SearchEmployeesParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          SearchEmployeesData,
          SearchEmployeesError,
          TData,
          ServiceOperationQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<SearchEmployeesError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.searchEmployees.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.searchEmployees.useQuery({
     *     query: {
     *         page: page
     *     }
     * })
     * ```
     */
    useQuery<TData = SearchEmployeesData>(
      parameters:
        | ServiceOperationQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>
        | (DeepReadonly<SearchEmployeesParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          SearchEmployeesData,
          SearchEmployeesError,
          TData,
          ServiceOperationQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<SearchEmployeesError>>;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<SearchEmployeesParameters> | void
    ): ServiceOperationInfiniteQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.searchEmployees.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends SearchEmployeesParameters,
      TQueryFnData = SearchEmployeesData,
      TData = OperationInfiniteData<TQueryFnData, SearchEmployeesParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>
        | (DeepReadonly<SearchEmployeesParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          SearchEmployeesError,
          TData,
          ServiceOperationInfiniteQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<SearchEmployeesError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.searchEmployees.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends SearchEmployeesParameters,
      TQueryFnData = SearchEmployeesData,
      TData = OperationInfiniteData<TQueryFnData, SearchEmployeesParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>
        | (DeepReadonly<SearchEmployeesParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          SearchEmployeesError,
          TData,
          ServiceOperationInfiniteQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<SearchEmployeesData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<SearchEmployeesError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const searchEmployeesTotal = qraft.employeesService.searchEmployees.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const searchEmployeesByParametersTotal = qraft.employeesService.searchEmployees.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             page: page
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchEmployeesSchema,
            SearchEmployeesData,
            TInfinite,
            SearchEmployeesParameters,
            SearchEmployeesError
          >
        | QueryFiltersByQueryKey<
            SearchEmployeesSchema,
            SearchEmployeesData,
            TInfinite,
            SearchEmployeesParameters,
            SearchEmployeesError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const searchEmployeesResults = qraft.employeesService.searchEmployees.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * searchEmployeesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const searchEmployeesCombinedResults = qraft.employeesService.searchEmployees.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * searchEmployeesCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          SearchEmployeesSchema,
          SearchEmployeesParameters,
          SearchEmployeesData,
          SearchEmployeesError
        >
      >,
      TCombinedResult = Array<UseQueryResult<SearchEmployeesData, SearchEmployeesError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<SearchEmployeesData, SearchEmployeesError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.employeesService.searchEmployees.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.employeesService.searchEmployees.useSuspenseQuery({
     *     query: {
     *         page: page
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = SearchEmployeesData>(
      parameters:
        | ServiceOperationQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>
        | (DeepReadonly<SearchEmployeesParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          SearchEmployeesData,
          SearchEmployeesError,
          TData,
          ServiceOperationQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<SearchEmployeesError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.searchEmployees.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends SearchEmployeesParameters, TData = SearchEmployeesData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>
        | (DeepReadonly<SearchEmployeesParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          SearchEmployeesData,
          SearchEmployeesError,
          OperationInfiniteData<TData, SearchEmployeesParameters>,
          ServiceOperationInfiniteQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<SearchEmployeesData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, SearchEmployeesParameters>,
      OperationError<SearchEmployeesError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const searchEmployeesData = qraft.employeesService.searchEmployees.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * searchEmployeesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const searchEmployeesCombinedData = qraft.employeesService.searchEmployees.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * searchEmployeesCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          SearchEmployeesSchema,
          SearchEmployeesParameters,
          SearchEmployeesData,
          SearchEmployeesError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<SearchEmployeesData, SearchEmployeesError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<SearchEmployeesData, SearchEmployeesError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        SearchEmployeesSchema,
        SearchEmployeesData,
        SearchEmployeesParameters,
        SearchEmployeesError
      > | void
    ): Promise<SearchEmployeesData>;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        SearchEmployeesSchema,
        SearchEmployeesData,
        SearchEmployeesParameters,
        SearchEmployeesError
      > | void
    ): Promise<void>;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        SearchEmployeesSchema,
        SearchEmployeesData,
        SearchEmployeesParameters,
        SearchEmployeesError
      > | void
    ): Promise<SearchEmployeesData>;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    fetchInfiniteQuery<TPageParam extends SearchEmployeesParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        SearchEmployeesSchema,
        SearchEmployeesData,
        SearchEmployeesParameters,
        DeepReadonly<TPageParam>,
        SearchEmployeesError
      > | void
    ): Promise<OperationInfiniteData<SearchEmployeesData, SearchEmployeesParameters>>;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    prefetchInfiniteQuery<TPageParam extends SearchEmployeesParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        SearchEmployeesSchema,
        SearchEmployeesData,
        SearchEmployeesParameters,
        DeepReadonly<TPageParam>,
        SearchEmployeesError
      > | void
    ): Promise<void>;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    ensureInfiniteQueryData<TPageParam extends SearchEmployeesParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        SearchEmployeesSchema,
        SearchEmployeesData,
        SearchEmployeesParameters,
        DeepReadonly<TPageParam>,
        SearchEmployeesError
      > | void
    ): Promise<OperationInfiniteData<SearchEmployeesData, SearchEmployeesParameters>>;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>
        | (DeepReadonly<SearchEmployeesParameters> | void)
    ): SearchEmployeesData | undefined;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>
        | (DeepReadonly<SearchEmployeesParameters> | void)
    ): OperationInfiniteData<SearchEmployeesData, SearchEmployeesParameters> | undefined;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchEmployeesSchema,
            SearchEmployeesData,
            TInfinite,
            SearchEmployeesParameters,
            SearchEmployeesError
          >
        | QueryFiltersByQueryKey<
            SearchEmployeesSchema,
            SearchEmployeesData,
            TInfinite,
            SearchEmployeesParameters,
            SearchEmployeesError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>,
            data: NoInfer<OperationInfiniteData<SearchEmployeesData, SearchEmployeesParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>,
            data: SearchEmployeesData | undefined,
          ]
        >;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>
        | (DeepReadonly<SearchEmployeesParameters> | void)
    ): QueryState<SearchEmployeesData, SearchEmployeesError> | undefined;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<SearchEmployeesParameters>
        | ServiceOperationInfiniteQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<SearchEmployeesData, SearchEmployeesParameters>, SearchEmployeesError>
      | undefined;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<SearchEmployeesParameters> | undefined)
        | ServiceOperationQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>,
      updater: Updater<
        NoInfer<SearchEmployeesData> | undefined,
        NoInfer<DeepReadonly<SearchEmployeesData>> | undefined
      >,
      options?: SetDataOptions
    ): SearchEmployeesData | undefined;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<SearchEmployeesParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<SearchEmployeesSchema, SearchEmployeesParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<SearchEmployeesData, SearchEmployeesParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<SearchEmployeesData, SearchEmployeesParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<SearchEmployeesData, SearchEmployeesParameters> | undefined;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            SearchEmployeesSchema,
            SearchEmployeesData,
            TInfinite,
            SearchEmployeesParameters,
            SearchEmployeesError
          >
        | QueryFiltersByQueryKey<
            SearchEmployeesSchema,
            SearchEmployeesData,
            TInfinite,
            SearchEmployeesParameters,
            SearchEmployeesError
          >,
      updater: Updater<NoInfer<SearchEmployeesData> | undefined, NoInfer<SearchEmployeesData> | undefined>,
      options?: SetDataOptions
    ): Array<SearchEmployeesData | undefined>;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        SearchEmployeesSchema,
        SearchEmployeesData,
        TInfinite,
        SearchEmployeesParameters,
        SearchEmployeesError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchEmployeesSchema,
            SearchEmployeesData,
            TInfinite,
            SearchEmployeesParameters,
            SearchEmployeesError
          >
        | QueryFiltersByQueryKey<
            SearchEmployeesSchema,
            SearchEmployeesData,
            TInfinite,
            SearchEmployeesParameters,
            SearchEmployeesError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchEmployeesSchema,
            SearchEmployeesData,
            TInfinite,
            SearchEmployeesParameters,
            SearchEmployeesError
          >
        | QueryFiltersByQueryKey<
            SearchEmployeesSchema,
            SearchEmployeesData,
            TInfinite,
            SearchEmployeesParameters,
            SearchEmployeesError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchEmployeesSchema,
            SearchEmployeesData,
            TInfinite,
            SearchEmployeesParameters,
            SearchEmployeesError
          >
        | QueryFiltersByQueryKey<
            SearchEmployeesSchema,
            SearchEmployeesData,
            TInfinite,
            SearchEmployeesParameters,
            SearchEmployeesError
          >
    ): void;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchEmployeesSchema,
            SearchEmployeesData,
            TInfinite,
            SearchEmployeesParameters,
            SearchEmployeesError
          >
        | QueryFiltersByQueryKey<
            SearchEmployeesSchema,
            SearchEmployeesData,
            TInfinite,
            SearchEmployeesParameters,
            SearchEmployeesError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Search Employees
     * @description Search employees with pagination and optional filters.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchEmployeesSchema,
            SearchEmployeesData,
            TInfinite,
            SearchEmployeesParameters,
            SearchEmployeesError
          >
        | QueryFiltersByQueryKey<
            SearchEmployeesSchema,
            SearchEmployeesData,
            TInfinite,
            SearchEmployeesParameters,
            SearchEmployeesError
          >
    ): number;
    schema: SearchEmployeesSchema;
    types: {
      parameters: SearchEmployeesParameters;
      data: SearchEmployeesData;
      error: SearchEmployeesError;
    };
  };
  /** @summary Batch Update Employees */
  batchUpdateEmployees: {
    /** @summary Batch Update Employees */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        BatchUpdateEmployeesBody,
        BatchUpdateEmployeesParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: BatchUpdateEmployeesSchema,
        options: ServiceOperationMutationFnOptions<
          BatchUpdateEmployeesBody,
          BatchUpdateEmployeesParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<BatchUpdateEmployeesData, BatchUpdateEmployeesError>>
    ): Promise<RequestFnResponse<BatchUpdateEmployeesData, BatchUpdateEmployeesError>>;
    /** @summary Batch Update Employees */
    getMutationKey(
      parameters: DeepReadonly<BatchUpdateEmployeesParameters> | void
    ): ServiceOperationMutationKey<BatchUpdateEmployeesSchema, BatchUpdateEmployeesParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Batch Update Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.batchUpdateEmployees.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.batchUpdateEmployees.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends BatchUpdateEmployeesBody, TContext = unknown>(
      parameters: DeepReadonly<BatchUpdateEmployeesParameters>,
      options?: ServiceOperationUseMutationOptions<
        BatchUpdateEmployeesSchema,
        BatchUpdateEmployeesData,
        BatchUpdateEmployeesParameters,
        TVariables,
        OperationError<BatchUpdateEmployeesError>,
        TContext
      >
    ): UseMutationResult<BatchUpdateEmployeesData, OperationError<BatchUpdateEmployeesError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Batch Update Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.batchUpdateEmployees.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.batchUpdateEmployees.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<BatchUpdateEmployeesBody, BatchUpdateEmployeesParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        BatchUpdateEmployeesSchema,
        BatchUpdateEmployeesData,
        BatchUpdateEmployeesParameters,
        TVariables,
        OperationError<BatchUpdateEmployeesError>,
        TContext
      >
    ): UseMutationResult<BatchUpdateEmployeesData, OperationError<BatchUpdateEmployeesError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Batch Update Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const batchUpdateEmployeesTotal = qraft.employeesService.batchUpdateEmployees.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const batchUpdateEmployeesTotal = qraft.employeesService.batchUpdateEmployees.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            BatchUpdateEmployeesBody,
            BatchUpdateEmployeesData,
            BatchUpdateEmployeesParameters,
            OperationError<BatchUpdateEmployeesError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BatchUpdateEmployeesSchema,
            BatchUpdateEmployeesBody,
            BatchUpdateEmployeesData,
            BatchUpdateEmployeesParameters,
            OperationError<BatchUpdateEmployeesError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Batch Update Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const batchUpdateEmployeesPendingMutationVariables = qraft.employeesService.batchUpdateEmployees.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const batchUpdateEmployeesMutationData = qraft.employeesService.batchUpdateEmployees.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        BatchUpdateEmployeesData,
        OperationError<BatchUpdateEmployeesError>,
        MutationVariables<BatchUpdateEmployeesBody, BatchUpdateEmployeesParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            BatchUpdateEmployeesBody,
            BatchUpdateEmployeesData,
            BatchUpdateEmployeesParameters,
            OperationError<BatchUpdateEmployeesError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BatchUpdateEmployeesSchema,
            BatchUpdateEmployeesBody,
            BatchUpdateEmployeesData,
            BatchUpdateEmployeesParameters,
            OperationError<BatchUpdateEmployeesError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          BatchUpdateEmployeesData,
          OperationError<BatchUpdateEmployeesError>,
          MutationVariables<BatchUpdateEmployeesBody, BatchUpdateEmployeesParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Batch Update Employees */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            BatchUpdateEmployeesBody,
            BatchUpdateEmployeesData,
            BatchUpdateEmployeesParameters,
            OperationError<BatchUpdateEmployeesError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BatchUpdateEmployeesSchema,
            BatchUpdateEmployeesBody,
            BatchUpdateEmployeesData,
            BatchUpdateEmployeesParameters,
            OperationError<BatchUpdateEmployeesError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Batch Update Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeesService.batchUpdateEmployees.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeesService.batchUpdateEmployees.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              BatchUpdateEmployeesBody,
              BatchUpdateEmployeesData,
              BatchUpdateEmployeesParameters,
              OperationError<BatchUpdateEmployeesError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              BatchUpdateEmployeesSchema,
              BatchUpdateEmployeesBody,
              BatchUpdateEmployeesData,
              BatchUpdateEmployeesParameters,
              OperationError<BatchUpdateEmployeesError>,
              TContext
            >
      ):
        | Mutation<
            BatchUpdateEmployeesData,
            BatchUpdateEmployeesError,
            MutationVariables<BatchUpdateEmployeesBody, BatchUpdateEmployeesParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              BatchUpdateEmployeesBody,
              BatchUpdateEmployeesData,
              BatchUpdateEmployeesParameters,
              OperationError<BatchUpdateEmployeesError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              BatchUpdateEmployeesSchema,
              BatchUpdateEmployeesBody,
              BatchUpdateEmployeesData,
              BatchUpdateEmployeesParameters,
              OperationError<BatchUpdateEmployeesError>,
              TContext
            >
      ): Array<
        Mutation<
          BatchUpdateEmployeesData,
          BatchUpdateEmployeesError,
          MutationVariables<BatchUpdateEmployeesBody, BatchUpdateEmployeesParameters>,
          TContext
        >
      >;
    };
    schema: BatchUpdateEmployeesSchema;
    types: {
      parameters: BatchUpdateEmployeesParameters;
      data: BatchUpdateEmployeesData;
      error: BatchUpdateEmployeesError;
      body: BatchUpdateEmployeesBody;
    };
  };
  /** @summary Update */
  updateEmployeesEmployeeIdPut: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateEmployeesEmployeeIdPutBody,
        UpdateEmployeesEmployeeIdPutParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateEmployeesEmployeeIdPutSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateEmployeesEmployeeIdPutBody,
          UpdateEmployeesEmployeeIdPutParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<UpdateEmployeesEmployeeIdPutData, UpdateEmployeesEmployeeIdPutError>>
    ): Promise<RequestFnResponse<UpdateEmployeesEmployeeIdPutData, UpdateEmployeesEmployeeIdPutError>>;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateEmployeesEmployeeIdPutParameters> | void
    ): ServiceOperationMutationKey<UpdateEmployeesEmployeeIdPutSchema, UpdateEmployeesEmployeeIdPutParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.updateEmployeesEmployeeIdPut.useMutation({
     *     path: {
     *         employee_id: employeeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.updateEmployeesEmployeeIdPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         employee_id: employeeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateEmployeesEmployeeIdPutBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateEmployeesEmployeeIdPutParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateEmployeesEmployeeIdPutSchema,
        UpdateEmployeesEmployeeIdPutData,
        UpdateEmployeesEmployeeIdPutParameters,
        TVariables,
        OperationError<UpdateEmployeesEmployeeIdPutError>,
        TContext
      >
    ): UseMutationResult<
      UpdateEmployeesEmployeeIdPutData,
      OperationError<UpdateEmployeesEmployeeIdPutError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.updateEmployeesEmployeeIdPut.useMutation({
     *     path: {
     *         employee_id: employeeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.updateEmployeesEmployeeIdPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         employee_id: employeeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateEmployeesEmployeeIdPutBody, UpdateEmployeesEmployeeIdPutParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateEmployeesEmployeeIdPutSchema,
        UpdateEmployeesEmployeeIdPutData,
        UpdateEmployeesEmployeeIdPutParameters,
        TVariables,
        OperationError<UpdateEmployeesEmployeeIdPutError>,
        TContext
      >
    ): UseMutationResult<
      UpdateEmployeesEmployeeIdPutData,
      OperationError<UpdateEmployeesEmployeeIdPutError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateEmployeesEmployeeIdPutTotal = qraft.employeesService.updateEmployeesEmployeeIdPut.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateEmployeesEmployeeIdPutTotal = qraft.employeesService.updateEmployeesEmployeeIdPut.useIsMutating({
     *     parameters: {
     *         path: {
     *             employee_id: employeeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateEmployeesEmployeeIdPutBody,
            UpdateEmployeesEmployeeIdPutData,
            UpdateEmployeesEmployeeIdPutParameters,
            OperationError<UpdateEmployeesEmployeeIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateEmployeesEmployeeIdPutSchema,
            UpdateEmployeesEmployeeIdPutBody,
            UpdateEmployeesEmployeeIdPutData,
            UpdateEmployeesEmployeeIdPutParameters,
            OperationError<UpdateEmployeesEmployeeIdPutError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateEmployeesEmployeeIdPutPendingMutationVariables = qraft.employeesService.updateEmployeesEmployeeIdPut.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateEmployeesEmployeeIdPutMutationData = qraft.employeesService.updateEmployeesEmployeeIdPut.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 employee_id: employeeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateEmployeesEmployeeIdPutData,
        OperationError<UpdateEmployeesEmployeeIdPutError>,
        MutationVariables<UpdateEmployeesEmployeeIdPutBody, UpdateEmployeesEmployeeIdPutParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateEmployeesEmployeeIdPutBody,
            UpdateEmployeesEmployeeIdPutData,
            UpdateEmployeesEmployeeIdPutParameters,
            OperationError<UpdateEmployeesEmployeeIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateEmployeesEmployeeIdPutSchema,
            UpdateEmployeesEmployeeIdPutBody,
            UpdateEmployeesEmployeeIdPutData,
            UpdateEmployeesEmployeeIdPutParameters,
            OperationError<UpdateEmployeesEmployeeIdPutError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateEmployeesEmployeeIdPutData,
          OperationError<UpdateEmployeesEmployeeIdPutError>,
          MutationVariables<UpdateEmployeesEmployeeIdPutBody, UpdateEmployeesEmployeeIdPutParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateEmployeesEmployeeIdPutBody,
            UpdateEmployeesEmployeeIdPutData,
            UpdateEmployeesEmployeeIdPutParameters,
            OperationError<UpdateEmployeesEmployeeIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateEmployeesEmployeeIdPutSchema,
            UpdateEmployeesEmployeeIdPutBody,
            UpdateEmployeesEmployeeIdPutData,
            UpdateEmployeesEmployeeIdPutParameters,
            OperationError<UpdateEmployeesEmployeeIdPutError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeesService.updateEmployeesEmployeeIdPut.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             employee_id: employeeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeesService.updateEmployeesEmployeeIdPut.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateEmployeesEmployeeIdPutBody,
              UpdateEmployeesEmployeeIdPutData,
              UpdateEmployeesEmployeeIdPutParameters,
              OperationError<UpdateEmployeesEmployeeIdPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateEmployeesEmployeeIdPutSchema,
              UpdateEmployeesEmployeeIdPutBody,
              UpdateEmployeesEmployeeIdPutData,
              UpdateEmployeesEmployeeIdPutParameters,
              OperationError<UpdateEmployeesEmployeeIdPutError>,
              TContext
            >
      ):
        | Mutation<
            UpdateEmployeesEmployeeIdPutData,
            UpdateEmployeesEmployeeIdPutError,
            MutationVariables<UpdateEmployeesEmployeeIdPutBody, UpdateEmployeesEmployeeIdPutParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateEmployeesEmployeeIdPutBody,
              UpdateEmployeesEmployeeIdPutData,
              UpdateEmployeesEmployeeIdPutParameters,
              OperationError<UpdateEmployeesEmployeeIdPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateEmployeesEmployeeIdPutSchema,
              UpdateEmployeesEmployeeIdPutBody,
              UpdateEmployeesEmployeeIdPutData,
              UpdateEmployeesEmployeeIdPutParameters,
              OperationError<UpdateEmployeesEmployeeIdPutError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateEmployeesEmployeeIdPutData,
          UpdateEmployeesEmployeeIdPutError,
          MutationVariables<UpdateEmployeesEmployeeIdPutBody, UpdateEmployeesEmployeeIdPutParameters>,
          TContext
        >
      >;
    };
    schema: UpdateEmployeesEmployeeIdPutSchema;
    types: {
      parameters: UpdateEmployeesEmployeeIdPutParameters;
      data: UpdateEmployeesEmployeeIdPutData;
      error: UpdateEmployeesEmployeeIdPutError;
      body: UpdateEmployeesEmployeeIdPutBody;
    };
  };
  /** @summary Upload File */
  uploadFileEmployeesEmployeeIdFilesPost: {
    /** @summary Upload File */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UploadFileEmployeesEmployeeIdFilesPostBody,
        UploadFileEmployeesEmployeeIdFilesPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UploadFileEmployeesEmployeeIdFilesPostSchema,
        options: ServiceOperationMutationFnOptions<
          UploadFileEmployeesEmployeeIdFilesPostBody,
          UploadFileEmployeesEmployeeIdFilesPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<UploadFileEmployeesEmployeeIdFilesPostData, UploadFileEmployeesEmployeeIdFilesPostError>
      >
    ): Promise<
      RequestFnResponse<UploadFileEmployeesEmployeeIdFilesPostData, UploadFileEmployeesEmployeeIdFilesPostError>
    >;
    /** @summary Upload File */
    getMutationKey(
      parameters: DeepReadonly<UploadFileEmployeesEmployeeIdFilesPostParameters> | void
    ): ServiceOperationMutationKey<
      UploadFileEmployeesEmployeeIdFilesPostSchema,
      UploadFileEmployeesEmployeeIdFilesPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Upload File
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.uploadFileEmployeesEmployeeIdFilesPost.useMutation({
     *     path: {
     *         employee_id: employeeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.uploadFileEmployeesEmployeeIdFilesPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         employee_id: employeeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UploadFileEmployeesEmployeeIdFilesPostBody, TContext = unknown>(
      parameters: DeepReadonly<UploadFileEmployeesEmployeeIdFilesPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        UploadFileEmployeesEmployeeIdFilesPostSchema,
        UploadFileEmployeesEmployeeIdFilesPostData,
        UploadFileEmployeesEmployeeIdFilesPostParameters,
        TVariables,
        OperationError<UploadFileEmployeesEmployeeIdFilesPostError>,
        TContext
      >
    ): UseMutationResult<
      UploadFileEmployeesEmployeeIdFilesPostData,
      OperationError<UploadFileEmployeesEmployeeIdFilesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Upload File
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.uploadFileEmployeesEmployeeIdFilesPost.useMutation({
     *     path: {
     *         employee_id: employeeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.uploadFileEmployeesEmployeeIdFilesPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         employee_id: employeeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        UploadFileEmployeesEmployeeIdFilesPostBody,
        UploadFileEmployeesEmployeeIdFilesPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UploadFileEmployeesEmployeeIdFilesPostSchema,
        UploadFileEmployeesEmployeeIdFilesPostData,
        UploadFileEmployeesEmployeeIdFilesPostParameters,
        TVariables,
        OperationError<UploadFileEmployeesEmployeeIdFilesPostError>,
        TContext
      >
    ): UseMutationResult<
      UploadFileEmployeesEmployeeIdFilesPostData,
      OperationError<UploadFileEmployeesEmployeeIdFilesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Upload File
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const uploadFileEmployeesEmployeeIdFilesPostTotal = qraft.employeesService.uploadFileEmployeesEmployeeIdFilesPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const uploadFileEmployeesEmployeeIdFilesPostTotal = qraft.employeesService.uploadFileEmployeesEmployeeIdFilesPost.useIsMutating({
     *     parameters: {
     *         path: {
     *             employee_id: employeeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UploadFileEmployeesEmployeeIdFilesPostBody,
            UploadFileEmployeesEmployeeIdFilesPostData,
            UploadFileEmployeesEmployeeIdFilesPostParameters,
            OperationError<UploadFileEmployeesEmployeeIdFilesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UploadFileEmployeesEmployeeIdFilesPostSchema,
            UploadFileEmployeesEmployeeIdFilesPostBody,
            UploadFileEmployeesEmployeeIdFilesPostData,
            UploadFileEmployeesEmployeeIdFilesPostParameters,
            OperationError<UploadFileEmployeesEmployeeIdFilesPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Upload File
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const uploadFileEmployeesEmployeeIdFilesPostPendingMutationVariables = qraft.employeesService.uploadFileEmployeesEmployeeIdFilesPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const uploadFileEmployeesEmployeeIdFilesPostMutationData = qraft.employeesService.uploadFileEmployeesEmployeeIdFilesPost.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 employee_id: employeeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UploadFileEmployeesEmployeeIdFilesPostData,
        OperationError<UploadFileEmployeesEmployeeIdFilesPostError>,
        MutationVariables<UploadFileEmployeesEmployeeIdFilesPostBody, UploadFileEmployeesEmployeeIdFilesPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UploadFileEmployeesEmployeeIdFilesPostBody,
            UploadFileEmployeesEmployeeIdFilesPostData,
            UploadFileEmployeesEmployeeIdFilesPostParameters,
            OperationError<UploadFileEmployeesEmployeeIdFilesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UploadFileEmployeesEmployeeIdFilesPostSchema,
            UploadFileEmployeesEmployeeIdFilesPostBody,
            UploadFileEmployeesEmployeeIdFilesPostData,
            UploadFileEmployeesEmployeeIdFilesPostParameters,
            OperationError<UploadFileEmployeesEmployeeIdFilesPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UploadFileEmployeesEmployeeIdFilesPostData,
          OperationError<UploadFileEmployeesEmployeeIdFilesPostError>,
          MutationVariables<
            UploadFileEmployeesEmployeeIdFilesPostBody,
            UploadFileEmployeesEmployeeIdFilesPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Upload File */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UploadFileEmployeesEmployeeIdFilesPostBody,
            UploadFileEmployeesEmployeeIdFilesPostData,
            UploadFileEmployeesEmployeeIdFilesPostParameters,
            OperationError<UploadFileEmployeesEmployeeIdFilesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UploadFileEmployeesEmployeeIdFilesPostSchema,
            UploadFileEmployeesEmployeeIdFilesPostBody,
            UploadFileEmployeesEmployeeIdFilesPostData,
            UploadFileEmployeesEmployeeIdFilesPostParameters,
            OperationError<UploadFileEmployeesEmployeeIdFilesPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Upload File
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeesService.uploadFileEmployeesEmployeeIdFilesPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             employee_id: employeeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeesService.uploadFileEmployeesEmployeeIdFilesPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UploadFileEmployeesEmployeeIdFilesPostBody,
              UploadFileEmployeesEmployeeIdFilesPostData,
              UploadFileEmployeesEmployeeIdFilesPostParameters,
              OperationError<UploadFileEmployeesEmployeeIdFilesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UploadFileEmployeesEmployeeIdFilesPostSchema,
              UploadFileEmployeesEmployeeIdFilesPostBody,
              UploadFileEmployeesEmployeeIdFilesPostData,
              UploadFileEmployeesEmployeeIdFilesPostParameters,
              OperationError<UploadFileEmployeesEmployeeIdFilesPostError>,
              TContext
            >
      ):
        | Mutation<
            UploadFileEmployeesEmployeeIdFilesPostData,
            UploadFileEmployeesEmployeeIdFilesPostError,
            MutationVariables<
              UploadFileEmployeesEmployeeIdFilesPostBody,
              UploadFileEmployeesEmployeeIdFilesPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UploadFileEmployeesEmployeeIdFilesPostBody,
              UploadFileEmployeesEmployeeIdFilesPostData,
              UploadFileEmployeesEmployeeIdFilesPostParameters,
              OperationError<UploadFileEmployeesEmployeeIdFilesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UploadFileEmployeesEmployeeIdFilesPostSchema,
              UploadFileEmployeesEmployeeIdFilesPostBody,
              UploadFileEmployeesEmployeeIdFilesPostData,
              UploadFileEmployeesEmployeeIdFilesPostParameters,
              OperationError<UploadFileEmployeesEmployeeIdFilesPostError>,
              TContext
            >
      ): Array<
        Mutation<
          UploadFileEmployeesEmployeeIdFilesPostData,
          UploadFileEmployeesEmployeeIdFilesPostError,
          MutationVariables<
            UploadFileEmployeesEmployeeIdFilesPostBody,
            UploadFileEmployeesEmployeeIdFilesPostParameters
          >,
          TContext
        >
      >;
    };
    schema: UploadFileEmployeesEmployeeIdFilesPostSchema;
    types: {
      parameters: UploadFileEmployeesEmployeeIdFilesPostParameters;
      data: UploadFileEmployeesEmployeeIdFilesPostData;
      error: UploadFileEmployeesEmployeeIdFilesPostError;
      body: UploadFileEmployeesEmployeeIdFilesPostBody;
    };
  };
  /** @summary Get Employee Worklogs */
  getEmployeeWorklogsEmployeesEmployeeIdWorklogsGet: {
    /** @summary Get Employee Worklogs */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
        options: {
          parameters: GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
      >
    >;
    /** @summary Get Employee Worklogs */
    getQueryKey(
      parameters: DeepReadonly<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>
    ): ServiceOperationQueryKey<
      GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
      GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Employee Worklogs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.getEmployeeWorklogsEmployeesEmployeeIdWorklogsGet.useQuery({
     *     path: {
     *         employee_id: employeeId
     *     },
     *     query: {
     *         page: page
     *     }
     * })
     * ```
     */
    useQuery<TData = GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >
        | DeepReadonly<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError,
          TData,
          ServiceOperationQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Employee Worklogs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.getEmployeeWorklogsEmployeesEmployeeIdWorklogsGet.useQuery({
     *     path: {
     *         employee_id: employeeId
     *     },
     *     query: {
     *         page: page
     *     }
     * })
     * ```
     */
    useQuery<TData = GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >
        | DeepReadonly<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError,
          TData,
          ServiceOperationQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError>>;
    /** @summary Get Employee Worklogs */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
      GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Employee Worklogs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.getEmployeeWorklogsEmployeesEmployeeIdWorklogsGet.useInfiniteQuery({
     *     path: {
     *         employee_id: employeeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
      TQueryFnData = GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >
        | DeepReadonly<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Employee Worklogs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.getEmployeeWorklogsEmployeesEmployeeIdWorklogsGet.useInfiniteQuery({
     *     path: {
     *         employee_id: employeeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
      TQueryFnData = GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >
        | DeepReadonly<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Employee Worklogs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getEmployeeWorklogsEmployeesEmployeeIdWorklogsGetTotal = qraft.employeesService.getEmployeeWorklogsEmployeesEmployeeIdWorklogsGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getEmployeeWorklogsEmployeesEmployeeIdWorklogsGetByParametersTotal = qraft.employeesService.getEmployeeWorklogsEmployeesEmployeeIdWorklogsGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             employee_id: employeeId
     *         },
     *         query: {
     *             page: page
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
            TInfinite,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
          >
        | QueryFiltersByQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
            TInfinite,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Employee Worklogs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getEmployeeWorklogsEmployeesEmployeeIdWorklogsGetResults = qraft.employeesService.getEmployeeWorklogsEmployeesEmployeeIdWorklogsGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 employee_id: employeeId1
     *             },
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             path: {
     *                 employee_id: employeeId2
     *             },
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * getEmployeeWorklogsEmployeesEmployeeIdWorklogsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getEmployeeWorklogsEmployeesEmployeeIdWorklogsGetCombinedResults = qraft.employeesService.getEmployeeWorklogsEmployeesEmployeeIdWorklogsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 employee_id: employeeId1
     *             },
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             path: {
     *                 employee_id: employeeId2
     *             },
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * getEmployeeWorklogsEmployeesEmployeeIdWorklogsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Employee Worklogs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.employeesService.getEmployeeWorklogsEmployeesEmployeeIdWorklogsGet.useSuspenseQuery({
     *     path: {
     *         employee_id: employeeId
     *     },
     *     query: {
     *         page: page
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >
        | DeepReadonly<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError,
          TData,
          ServiceOperationQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Employee Worklogs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.getEmployeeWorklogsEmployeesEmployeeIdWorklogsGet.useSuspenseInfiniteQuery({
     *     path: {
     *         employee_id: employeeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
      TData = GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >
        | DeepReadonly<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError,
          OperationInfiniteData<TData, GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>,
      OperationError<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Employee Worklogs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData = qraft.employeesService.getEmployeeWorklogsEmployeesEmployeeIdWorklogsGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 employee_id: employeeId1
     *             },
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             path: {
     *                 employee_id: employeeId2
     *             },
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * getEmployeeWorklogsEmployeesEmployeeIdWorklogsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getEmployeeWorklogsEmployeesEmployeeIdWorklogsGetCombinedData = qraft.employeesService.getEmployeeWorklogsEmployeesEmployeeIdWorklogsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 employee_id: employeeId1
     *             },
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             path: {
     *                 employee_id: employeeId2
     *             },
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * getEmployeeWorklogsEmployeesEmployeeIdWorklogsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
              GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get Employee Worklogs */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
      >
    ): Promise<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData>;
    /** @summary Get Employee Worklogs */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
      >
    ): Promise<void>;
    /** @summary Get Employee Worklogs */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
      >
    ): Promise<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData>;
    /** @summary Get Employee Worklogs */
    fetchInfiniteQuery<TPageParam extends GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
        DeepReadonly<TPageParam>,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
      >
    >;
    /** @summary Get Employee Worklogs */
    prefetchInfiniteQuery<TPageParam extends GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
        DeepReadonly<TPageParam>,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
      >
    ): Promise<void>;
    /** @summary Get Employee Worklogs */
    ensureInfiniteQueryData<TPageParam extends GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
        DeepReadonly<TPageParam>,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
      >
    >;
    /** @summary Get Employee Worklogs */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >
        | DeepReadonly<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>
    ): GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData | undefined;
    /** @summary Get Employee Worklogs */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >
        | DeepReadonly<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>
    ):
      | OperationInfiniteData<
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
        >
      | undefined;
    /** @summary Get Employee Worklogs */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
            TInfinite,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
          >
        | QueryFiltersByQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
            TInfinite,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
              GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
                    GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
              GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
            >,
            data: GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData | undefined,
          ]
        >;
    /** @summary Get Employee Worklogs */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >
        | DeepReadonly<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>
    ):
      | QueryState<
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
        >
      | undefined;
    /** @summary Get Employee Worklogs */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
        >
      | undefined;
    /** @summary Get Employee Worklogs */
    setQueryData(
      parameters:
        | DeepReadonly<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>
        | ServiceOperationQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >,
      updater: Updater<
        NoInfer<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData> | undefined,
        NoInfer<DeepReadonly<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData | undefined;
    /** @summary Get Employee Worklogs */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
              GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
                GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
          GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters
        >
      | undefined;
    /** @summary Get Employee Worklogs */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
            TInfinite,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
          >
        | QueryFiltersByQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
            TInfinite,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
          >,
      updater: Updater<
        NoInfer<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData> | undefined,
        NoInfer<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData | undefined>;
    /** @summary Get Employee Worklogs */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
        TInfinite,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
        GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get Employee Worklogs */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
            TInfinite,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
          >
        | QueryFiltersByQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
            TInfinite,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get Employee Worklogs */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
            TInfinite,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
          >
        | QueryFiltersByQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
            TInfinite,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get Employee Worklogs */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
            TInfinite,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
          >
        | QueryFiltersByQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
            TInfinite,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
          >
    ): void;
    /** @summary Get Employee Worklogs */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
            TInfinite,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
          >
        | QueryFiltersByQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
            TInfinite,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get Employee Worklogs */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
            TInfinite,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
          >
        | QueryFiltersByQueryKey<
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData,
            TInfinite,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters,
            GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError
          >
    ): number;
    schema: GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema;
    types: {
      parameters: GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters;
      data: GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData;
      error: GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError;
    };
  };
  /** @summary Admin List Employees */
  adminListEmployees: {
    /** @summary Admin List Employees */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<AdminListEmployeesParameters, TMeta, TSignal> | void),
      client?: (
        schema: AdminListEmployeesSchema,
        options: {
          parameters: AdminListEmployeesParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<AdminListEmployeesData, AdminListEmployeesError>>
    ): Promise<RequestFnResponse<AdminListEmployeesData, AdminListEmployeesError>>;
    /** @summary Admin List Employees */
    getQueryKey(
      parameters: DeepReadonly<AdminListEmployeesParameters> | void
    ): ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Admin List Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.adminListEmployees.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.adminListEmployees.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = AdminListEmployeesData>(
      parameters:
        | ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | (DeepReadonly<AdminListEmployeesParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          AdminListEmployeesData,
          AdminListEmployeesError,
          TData,
          ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<AdminListEmployeesError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Admin List Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.adminListEmployees.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.adminListEmployees.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = AdminListEmployeesData>(
      parameters:
        | ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | (DeepReadonly<AdminListEmployeesParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          AdminListEmployeesData,
          AdminListEmployeesError,
          TData,
          ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<AdminListEmployeesError>>;
    /** @summary Admin List Employees */
    getInfiniteQueryKey(
      parameters: DeepReadonly<AdminListEmployeesParameters> | void
    ): ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Admin List Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.adminListEmployees.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends AdminListEmployeesParameters,
      TQueryFnData = AdminListEmployeesData,
      TData = OperationInfiniteData<TQueryFnData, AdminListEmployeesParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | (DeepReadonly<AdminListEmployeesParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          AdminListEmployeesError,
          TData,
          ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<AdminListEmployeesError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Admin List Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.adminListEmployees.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends AdminListEmployeesParameters,
      TQueryFnData = AdminListEmployeesData,
      TData = OperationInfiniteData<TQueryFnData, AdminListEmployeesParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | (DeepReadonly<AdminListEmployeesParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          AdminListEmployeesError,
          TData,
          ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<AdminListEmployeesData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<AdminListEmployeesError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Admin List Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const adminListEmployeesTotal = qraft.employeesService.adminListEmployees.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const adminListEmployeesByParametersTotal = qraft.employeesService.adminListEmployees.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
        | QueryFiltersByQueryKey<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Admin List Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const adminListEmployeesResults = qraft.employeesService.adminListEmployees.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * adminListEmployeesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const adminListEmployeesCombinedResults = qraft.employeesService.adminListEmployees.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * adminListEmployeesCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          AdminListEmployeesSchema,
          AdminListEmployeesParameters,
          AdminListEmployeesData,
          AdminListEmployeesError
        >
      >,
      TCombinedResult = Array<UseQueryResult<AdminListEmployeesData, AdminListEmployeesError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<AdminListEmployeesData, AdminListEmployeesError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Admin List Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.employeesService.adminListEmployees.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.employeesService.adminListEmployees.useSuspenseQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = AdminListEmployeesData>(
      parameters:
        | ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | (DeepReadonly<AdminListEmployeesParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          AdminListEmployeesData,
          AdminListEmployeesError,
          TData,
          ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<AdminListEmployeesError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Admin List Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.adminListEmployees.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends AdminListEmployeesParameters, TData = AdminListEmployeesData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | (DeepReadonly<AdminListEmployeesParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          AdminListEmployeesData,
          AdminListEmployeesError,
          OperationInfiniteData<TData, AdminListEmployeesParameters>,
          ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<AdminListEmployeesData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, AdminListEmployeesParameters>,
      OperationError<AdminListEmployeesError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Admin List Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const adminListEmployeesData = qraft.employeesService.adminListEmployees.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * adminListEmployeesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const adminListEmployeesCombinedData = qraft.employeesService.adminListEmployees.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * adminListEmployeesCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          AdminListEmployeesSchema,
          AdminListEmployeesParameters,
          AdminListEmployeesData,
          AdminListEmployeesError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<AdminListEmployeesData, AdminListEmployeesError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<AdminListEmployeesData, AdminListEmployeesError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Admin List Employees */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        AdminListEmployeesSchema,
        AdminListEmployeesData,
        AdminListEmployeesParameters,
        AdminListEmployeesError
      > | void
    ): Promise<AdminListEmployeesData>;
    /** @summary Admin List Employees */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        AdminListEmployeesSchema,
        AdminListEmployeesData,
        AdminListEmployeesParameters,
        AdminListEmployeesError
      > | void
    ): Promise<void>;
    /** @summary Admin List Employees */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        AdminListEmployeesSchema,
        AdminListEmployeesData,
        AdminListEmployeesParameters,
        AdminListEmployeesError
      > | void
    ): Promise<AdminListEmployeesData>;
    /** @summary Admin List Employees */
    fetchInfiniteQuery<TPageParam extends AdminListEmployeesParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        AdminListEmployeesSchema,
        AdminListEmployeesData,
        AdminListEmployeesParameters,
        DeepReadonly<TPageParam>,
        AdminListEmployeesError
      > | void
    ): Promise<OperationInfiniteData<AdminListEmployeesData, AdminListEmployeesParameters>>;
    /** @summary Admin List Employees */
    prefetchInfiniteQuery<TPageParam extends AdminListEmployeesParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        AdminListEmployeesSchema,
        AdminListEmployeesData,
        AdminListEmployeesParameters,
        DeepReadonly<TPageParam>,
        AdminListEmployeesError
      > | void
    ): Promise<void>;
    /** @summary Admin List Employees */
    ensureInfiniteQueryData<TPageParam extends AdminListEmployeesParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        AdminListEmployeesSchema,
        AdminListEmployeesData,
        AdminListEmployeesParameters,
        DeepReadonly<TPageParam>,
        AdminListEmployeesError
      > | void
    ): Promise<OperationInfiniteData<AdminListEmployeesData, AdminListEmployeesParameters>>;
    /** @summary Admin List Employees */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | (DeepReadonly<AdminListEmployeesParameters> | void)
    ): AdminListEmployeesData | undefined;
    /** @summary Admin List Employees */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | (DeepReadonly<AdminListEmployeesParameters> | void)
    ): OperationInfiniteData<AdminListEmployeesData, AdminListEmployeesParameters> | undefined;
    /** @summary Admin List Employees */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
        | QueryFiltersByQueryKey<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>,
            data: NoInfer<OperationInfiniteData<AdminListEmployeesData, AdminListEmployeesParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>,
            data: AdminListEmployeesData | undefined,
          ]
        >;
    /** @summary Admin List Employees */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | (DeepReadonly<AdminListEmployeesParameters> | void)
    ): QueryState<AdminListEmployeesData, AdminListEmployeesError> | undefined;
    /** @summary Admin List Employees */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<AdminListEmployeesParameters>
        | ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<AdminListEmployeesData, AdminListEmployeesParameters>, AdminListEmployeesError>
      | undefined;
    /** @summary Admin List Employees */
    setQueryData(
      parameters:
        | (DeepReadonly<AdminListEmployeesParameters> | undefined)
        | ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>,
      updater: Updater<
        NoInfer<AdminListEmployeesData> | undefined,
        NoInfer<DeepReadonly<AdminListEmployeesData>> | undefined
      >,
      options?: SetDataOptions
    ): AdminListEmployeesData | undefined;
    /** @summary Admin List Employees */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<AdminListEmployeesParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<AdminListEmployeesData, AdminListEmployeesParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<AdminListEmployeesData, AdminListEmployeesParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<AdminListEmployeesData, AdminListEmployeesParameters> | undefined;
    /** @summary Admin List Employees */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
        | QueryFiltersByQueryKey<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >,
      updater: Updater<NoInfer<AdminListEmployeesData> | undefined, NoInfer<AdminListEmployeesData> | undefined>,
      options?: SetDataOptions
    ): Array<AdminListEmployeesData | undefined>;
    /** @summary Admin List Employees */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        AdminListEmployeesSchema,
        AdminListEmployeesData,
        TInfinite,
        AdminListEmployeesParameters,
        AdminListEmployeesError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Admin List Employees */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
        | QueryFiltersByQueryKey<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Admin List Employees */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
        | QueryFiltersByQueryKey<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Admin List Employees */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
        | QueryFiltersByQueryKey<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
    ): void;
    /** @summary Admin List Employees */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
        | QueryFiltersByQueryKey<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Admin List Employees */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
        | QueryFiltersByQueryKey<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
    ): number;
    schema: AdminListEmployeesSchema;
    types: {
      parameters: AdminListEmployeesParameters;
      data: AdminListEmployeesData;
      error: AdminListEmployeesError;
    };
  };
  /** @summary Switch To Employee */
  switchToEmployee: {
    /** @summary Switch To Employee */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<SwitchToEmployeeBody, SwitchToEmployeeParameters, TMeta, TSignal>,
      client?: (
        schema: SwitchToEmployeeSchema,
        options: ServiceOperationMutationFnOptions<SwitchToEmployeeBody, SwitchToEmployeeParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<SwitchToEmployeeData, SwitchToEmployeeError>>
    ): Promise<RequestFnResponse<SwitchToEmployeeData, SwitchToEmployeeError>>;
    /** @summary Switch To Employee */
    getMutationKey(
      parameters: DeepReadonly<SwitchToEmployeeParameters> | void
    ): ServiceOperationMutationKey<SwitchToEmployeeSchema, SwitchToEmployeeParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Switch To Employee
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.switchToEmployee.useMutation({
     *     query: {
     *         employee_id: employeeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.switchToEmployee.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     query: {
     *         employee_id: employeeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends SwitchToEmployeeBody, TContext = unknown>(
      parameters: DeepReadonly<SwitchToEmployeeParameters>,
      options?: ServiceOperationUseMutationOptions<
        SwitchToEmployeeSchema,
        SwitchToEmployeeData,
        SwitchToEmployeeParameters,
        TVariables,
        OperationError<SwitchToEmployeeError>,
        TContext
      >
    ): UseMutationResult<SwitchToEmployeeData, OperationError<SwitchToEmployeeError>, TVariables | void, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Switch To Employee
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.switchToEmployee.useMutation({
     *     query: {
     *         employee_id: employeeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.switchToEmployee.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     query: {
     *         employee_id: employeeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<SwitchToEmployeeBody, SwitchToEmployeeParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SwitchToEmployeeSchema,
        SwitchToEmployeeData,
        SwitchToEmployeeParameters,
        TVariables,
        OperationError<SwitchToEmployeeError>,
        TContext
      >
    ): UseMutationResult<SwitchToEmployeeData, OperationError<SwitchToEmployeeError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Switch To Employee
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const switchToEmployeeTotal = qraft.employeesService.switchToEmployee.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const switchToEmployeeTotal = qraft.employeesService.switchToEmployee.useIsMutating({
     *     parameters: {
     *         query: {
     *             employee_id: employeeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SwitchToEmployeeBody,
            SwitchToEmployeeData,
            SwitchToEmployeeParameters,
            OperationError<SwitchToEmployeeError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SwitchToEmployeeSchema,
            SwitchToEmployeeBody,
            SwitchToEmployeeData,
            SwitchToEmployeeParameters,
            OperationError<SwitchToEmployeeError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Switch To Employee
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const switchToEmployeePendingMutationVariables = qraft.employeesService.switchToEmployee.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const switchToEmployeeMutationData = qraft.employeesService.switchToEmployee.useMutationState({
     *     filters: {
     *         parameters: {
     *             query: {
     *                 employee_id: employeeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SwitchToEmployeeData,
        OperationError<SwitchToEmployeeError>,
        MutationVariables<SwitchToEmployeeBody, SwitchToEmployeeParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SwitchToEmployeeBody,
            SwitchToEmployeeData,
            SwitchToEmployeeParameters,
            OperationError<SwitchToEmployeeError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SwitchToEmployeeSchema,
            SwitchToEmployeeBody,
            SwitchToEmployeeData,
            SwitchToEmployeeParameters,
            OperationError<SwitchToEmployeeError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SwitchToEmployeeData,
          OperationError<SwitchToEmployeeError>,
          MutationVariables<SwitchToEmployeeBody, SwitchToEmployeeParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Switch To Employee */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SwitchToEmployeeBody,
            SwitchToEmployeeData,
            SwitchToEmployeeParameters,
            OperationError<SwitchToEmployeeError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SwitchToEmployeeSchema,
            SwitchToEmployeeBody,
            SwitchToEmployeeData,
            SwitchToEmployeeParameters,
            OperationError<SwitchToEmployeeError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Switch To Employee
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeesService.switchToEmployee.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         query: {
     *             employee_id: employeeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeesService.switchToEmployee.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SwitchToEmployeeBody,
              SwitchToEmployeeData,
              SwitchToEmployeeParameters,
              OperationError<SwitchToEmployeeError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SwitchToEmployeeSchema,
              SwitchToEmployeeBody,
              SwitchToEmployeeData,
              SwitchToEmployeeParameters,
              OperationError<SwitchToEmployeeError>,
              TContext
            >
      ):
        | Mutation<
            SwitchToEmployeeData,
            SwitchToEmployeeError,
            MutationVariables<SwitchToEmployeeBody, SwitchToEmployeeParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SwitchToEmployeeBody,
              SwitchToEmployeeData,
              SwitchToEmployeeParameters,
              OperationError<SwitchToEmployeeError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SwitchToEmployeeSchema,
              SwitchToEmployeeBody,
              SwitchToEmployeeData,
              SwitchToEmployeeParameters,
              OperationError<SwitchToEmployeeError>,
              TContext
            >
      ): Array<
        Mutation<
          SwitchToEmployeeData,
          SwitchToEmployeeError,
          MutationVariables<SwitchToEmployeeBody, SwitchToEmployeeParameters>,
          TContext
        >
      >;
    };
    schema: SwitchToEmployeeSchema;
    types: {
      parameters: SwitchToEmployeeParameters;
      data: SwitchToEmployeeData;
      error: SwitchToEmployeeError;
      body: SwitchToEmployeeBody;
    };
  };
  /**
   * @deprecated
   * @summary Admin Switch To Employee
   * @description Use /switch_to_employee instead
   */
  adminSwitchToEmployee: {
    /**
     * @deprecated
     * @summary Admin Switch To Employee
     * @description Use /switch_to_employee instead
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        AdminSwitchToEmployeeBody,
        AdminSwitchToEmployeeParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: AdminSwitchToEmployeeSchema,
        options: ServiceOperationMutationFnOptions<
          AdminSwitchToEmployeeBody,
          AdminSwitchToEmployeeParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<AdminSwitchToEmployeeData, AdminSwitchToEmployeeError>>
    ): Promise<RequestFnResponse<AdminSwitchToEmployeeData, AdminSwitchToEmployeeError>>;
    /**
     * @deprecated
     * @summary Admin Switch To Employee
     * @description Use /switch_to_employee instead
     */
    getMutationKey(
      parameters: DeepReadonly<AdminSwitchToEmployeeParameters> | void
    ): ServiceOperationMutationKey<AdminSwitchToEmployeeSchema, AdminSwitchToEmployeeParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @deprecated
     * @summary Admin Switch To Employee
     * @description Use /switch_to_employee instead
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.adminSwitchToEmployee.useMutation({
     *     query: {
     *         employee_id: employeeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.adminSwitchToEmployee.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     query: {
     *         employee_id: employeeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends AdminSwitchToEmployeeBody, TContext = unknown>(
      parameters: DeepReadonly<AdminSwitchToEmployeeParameters>,
      options?: ServiceOperationUseMutationOptions<
        AdminSwitchToEmployeeSchema,
        AdminSwitchToEmployeeData,
        AdminSwitchToEmployeeParameters,
        TVariables,
        OperationError<AdminSwitchToEmployeeError>,
        TContext
      >
    ): UseMutationResult<
      AdminSwitchToEmployeeData,
      OperationError<AdminSwitchToEmployeeError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @deprecated
     * @summary Admin Switch To Employee
     * @description Use /switch_to_employee instead
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.adminSwitchToEmployee.useMutation({
     *     query: {
     *         employee_id: employeeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.adminSwitchToEmployee.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     query: {
     *         employee_id: employeeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<AdminSwitchToEmployeeBody, AdminSwitchToEmployeeParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        AdminSwitchToEmployeeSchema,
        AdminSwitchToEmployeeData,
        AdminSwitchToEmployeeParameters,
        TVariables,
        OperationError<AdminSwitchToEmployeeError>,
        TContext
      >
    ): UseMutationResult<AdminSwitchToEmployeeData, OperationError<AdminSwitchToEmployeeError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @deprecated
     * @summary Admin Switch To Employee
     * @description Use /switch_to_employee instead
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const adminSwitchToEmployeeTotal = qraft.employeesService.adminSwitchToEmployee.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const adminSwitchToEmployeeTotal = qraft.employeesService.adminSwitchToEmployee.useIsMutating({
     *     parameters: {
     *         query: {
     *             employee_id: employeeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            AdminSwitchToEmployeeBody,
            AdminSwitchToEmployeeData,
            AdminSwitchToEmployeeParameters,
            OperationError<AdminSwitchToEmployeeError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AdminSwitchToEmployeeSchema,
            AdminSwitchToEmployeeBody,
            AdminSwitchToEmployeeData,
            AdminSwitchToEmployeeParameters,
            OperationError<AdminSwitchToEmployeeError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @deprecated
     * @summary Admin Switch To Employee
     * @description Use /switch_to_employee instead
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const adminSwitchToEmployeePendingMutationVariables = qraft.employeesService.adminSwitchToEmployee.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const adminSwitchToEmployeeMutationData = qraft.employeesService.adminSwitchToEmployee.useMutationState({
     *     filters: {
     *         parameters: {
     *             query: {
     *                 employee_id: employeeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        AdminSwitchToEmployeeData,
        OperationError<AdminSwitchToEmployeeError>,
        MutationVariables<AdminSwitchToEmployeeBody, AdminSwitchToEmployeeParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            AdminSwitchToEmployeeBody,
            AdminSwitchToEmployeeData,
            AdminSwitchToEmployeeParameters,
            OperationError<AdminSwitchToEmployeeError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AdminSwitchToEmployeeSchema,
            AdminSwitchToEmployeeBody,
            AdminSwitchToEmployeeData,
            AdminSwitchToEmployeeParameters,
            OperationError<AdminSwitchToEmployeeError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          AdminSwitchToEmployeeData,
          OperationError<AdminSwitchToEmployeeError>,
          MutationVariables<AdminSwitchToEmployeeBody, AdminSwitchToEmployeeParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @deprecated
     * @summary Admin Switch To Employee
     * @description Use /switch_to_employee instead
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            AdminSwitchToEmployeeBody,
            AdminSwitchToEmployeeData,
            AdminSwitchToEmployeeParameters,
            OperationError<AdminSwitchToEmployeeError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AdminSwitchToEmployeeSchema,
            AdminSwitchToEmployeeBody,
            AdminSwitchToEmployeeData,
            AdminSwitchToEmployeeParameters,
            OperationError<AdminSwitchToEmployeeError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @deprecated
     * @summary Admin Switch To Employee
     * @description Use /switch_to_employee instead
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeesService.adminSwitchToEmployee.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         query: {
     *             employee_id: employeeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeesService.adminSwitchToEmployee.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              AdminSwitchToEmployeeBody,
              AdminSwitchToEmployeeData,
              AdminSwitchToEmployeeParameters,
              OperationError<AdminSwitchToEmployeeError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AdminSwitchToEmployeeSchema,
              AdminSwitchToEmployeeBody,
              AdminSwitchToEmployeeData,
              AdminSwitchToEmployeeParameters,
              OperationError<AdminSwitchToEmployeeError>,
              TContext
            >
      ):
        | Mutation<
            AdminSwitchToEmployeeData,
            AdminSwitchToEmployeeError,
            MutationVariables<AdminSwitchToEmployeeBody, AdminSwitchToEmployeeParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              AdminSwitchToEmployeeBody,
              AdminSwitchToEmployeeData,
              AdminSwitchToEmployeeParameters,
              OperationError<AdminSwitchToEmployeeError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AdminSwitchToEmployeeSchema,
              AdminSwitchToEmployeeBody,
              AdminSwitchToEmployeeData,
              AdminSwitchToEmployeeParameters,
              OperationError<AdminSwitchToEmployeeError>,
              TContext
            >
      ): Array<
        Mutation<
          AdminSwitchToEmployeeData,
          AdminSwitchToEmployeeError,
          MutationVariables<AdminSwitchToEmployeeBody, AdminSwitchToEmployeeParameters>,
          TContext
        >
      >;
    };
    schema: AdminSwitchToEmployeeSchema;
    types: {
      parameters: AdminSwitchToEmployeeParameters;
      data: AdminSwitchToEmployeeData;
      error: AdminSwitchToEmployeeError;
      body: AdminSwitchToEmployeeBody;
    };
  };
  /** @summary Switch To Office */
  switchToOffice: {
    /** @summary Switch To Office */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<SwitchToOfficeBody, SwitchToOfficeParameters, TMeta, TSignal>,
      client?: (
        schema: SwitchToOfficeSchema,
        options: ServiceOperationMutationFnOptions<SwitchToOfficeBody, SwitchToOfficeParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<SwitchToOfficeData, SwitchToOfficeError>>
    ): Promise<RequestFnResponse<SwitchToOfficeData, SwitchToOfficeError>>;
    /** @summary Switch To Office */
    getMutationKey(
      parameters: DeepReadonly<SwitchToOfficeParameters> | void
    ): ServiceOperationMutationKey<SwitchToOfficeSchema, SwitchToOfficeParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Switch To Office
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.switchToOffice.useMutation({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.switchToOffice.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     query: {
     *         office_id: officeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends SwitchToOfficeBody, TContext = unknown>(
      parameters: DeepReadonly<SwitchToOfficeParameters>,
      options?: ServiceOperationUseMutationOptions<
        SwitchToOfficeSchema,
        SwitchToOfficeData,
        SwitchToOfficeParameters,
        TVariables,
        OperationError<SwitchToOfficeError>,
        TContext
      >
    ): UseMutationResult<SwitchToOfficeData, OperationError<SwitchToOfficeError>, TVariables | void, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Switch To Office
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.switchToOffice.useMutation({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.switchToOffice.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     query: {
     *         office_id: officeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends MutationVariables<SwitchToOfficeBody, SwitchToOfficeParameters>, TContext = unknown>(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SwitchToOfficeSchema,
        SwitchToOfficeData,
        SwitchToOfficeParameters,
        TVariables,
        OperationError<SwitchToOfficeError>,
        TContext
      >
    ): UseMutationResult<SwitchToOfficeData, OperationError<SwitchToOfficeError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Switch To Office
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const switchToOfficeTotal = qraft.employeesService.switchToOffice.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const switchToOfficeTotal = qraft.employeesService.switchToOffice.useIsMutating({
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SwitchToOfficeBody,
            SwitchToOfficeData,
            SwitchToOfficeParameters,
            OperationError<SwitchToOfficeError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SwitchToOfficeSchema,
            SwitchToOfficeBody,
            SwitchToOfficeData,
            SwitchToOfficeParameters,
            OperationError<SwitchToOfficeError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Switch To Office
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const switchToOfficePendingMutationVariables = qraft.employeesService.switchToOffice.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const switchToOfficeMutationData = qraft.employeesService.switchToOffice.useMutationState({
     *     filters: {
     *         parameters: {
     *             query: {
     *                 office_id: officeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SwitchToOfficeData,
        OperationError<SwitchToOfficeError>,
        MutationVariables<SwitchToOfficeBody, SwitchToOfficeParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SwitchToOfficeBody,
            SwitchToOfficeData,
            SwitchToOfficeParameters,
            OperationError<SwitchToOfficeError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SwitchToOfficeSchema,
            SwitchToOfficeBody,
            SwitchToOfficeData,
            SwitchToOfficeParameters,
            OperationError<SwitchToOfficeError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SwitchToOfficeData,
          OperationError<SwitchToOfficeError>,
          MutationVariables<SwitchToOfficeBody, SwitchToOfficeParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Switch To Office */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SwitchToOfficeBody,
            SwitchToOfficeData,
            SwitchToOfficeParameters,
            OperationError<SwitchToOfficeError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SwitchToOfficeSchema,
            SwitchToOfficeBody,
            SwitchToOfficeData,
            SwitchToOfficeParameters,
            OperationError<SwitchToOfficeError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Switch To Office
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeesService.switchToOffice.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeesService.switchToOffice.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SwitchToOfficeBody,
              SwitchToOfficeData,
              SwitchToOfficeParameters,
              OperationError<SwitchToOfficeError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SwitchToOfficeSchema,
              SwitchToOfficeBody,
              SwitchToOfficeData,
              SwitchToOfficeParameters,
              OperationError<SwitchToOfficeError>,
              TContext
            >
      ):
        | Mutation<
            SwitchToOfficeData,
            SwitchToOfficeError,
            MutationVariables<SwitchToOfficeBody, SwitchToOfficeParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SwitchToOfficeBody,
              SwitchToOfficeData,
              SwitchToOfficeParameters,
              OperationError<SwitchToOfficeError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SwitchToOfficeSchema,
              SwitchToOfficeBody,
              SwitchToOfficeData,
              SwitchToOfficeParameters,
              OperationError<SwitchToOfficeError>,
              TContext
            >
      ): Array<
        Mutation<
          SwitchToOfficeData,
          SwitchToOfficeError,
          MutationVariables<SwitchToOfficeBody, SwitchToOfficeParameters>,
          TContext
        >
      >;
    };
    schema: SwitchToOfficeSchema;
    types: {
      parameters: SwitchToOfficeParameters;
      data: SwitchToOfficeData;
      error: SwitchToOfficeError;
      body: SwitchToOfficeBody;
    };
  };
  /** @summary Reset Employee Cookie */
  resetEmployeeCookie: {
    /** @summary Reset Employee Cookie */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        ResetEmployeeCookieBody,
        ResetEmployeeCookieParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: ResetEmployeeCookieSchema,
        options: ServiceOperationMutationFnOptions<
          ResetEmployeeCookieBody,
          ResetEmployeeCookieParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<ResetEmployeeCookieData, ResetEmployeeCookieError>>
    ): Promise<RequestFnResponse<ResetEmployeeCookieData, ResetEmployeeCookieError>>;
    /** @summary Reset Employee Cookie */
    getMutationKey(
      parameters: DeepReadonly<ResetEmployeeCookieParameters> | void
    ): ServiceOperationMutationKey<ResetEmployeeCookieSchema, ResetEmployeeCookieParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Reset Employee Cookie
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.resetEmployeeCookie.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.resetEmployeeCookie.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends ResetEmployeeCookieBody, TContext = unknown>(
      parameters: DeepReadonly<ResetEmployeeCookieParameters>,
      options?: ServiceOperationUseMutationOptions<
        ResetEmployeeCookieSchema,
        ResetEmployeeCookieData,
        ResetEmployeeCookieParameters,
        TVariables,
        OperationError<ResetEmployeeCookieError>,
        TContext
      >
    ): UseMutationResult<
      ResetEmployeeCookieData,
      OperationError<ResetEmployeeCookieError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Reset Employee Cookie
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.resetEmployeeCookie.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.resetEmployeeCookie.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<ResetEmployeeCookieBody, ResetEmployeeCookieParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        ResetEmployeeCookieSchema,
        ResetEmployeeCookieData,
        ResetEmployeeCookieParameters,
        TVariables,
        OperationError<ResetEmployeeCookieError>,
        TContext
      >
    ): UseMutationResult<ResetEmployeeCookieData, OperationError<ResetEmployeeCookieError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Reset Employee Cookie
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const resetEmployeeCookieTotal = qraft.employeesService.resetEmployeeCookie.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const resetEmployeeCookieTotal = qraft.employeesService.resetEmployeeCookie.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            ResetEmployeeCookieBody,
            ResetEmployeeCookieData,
            ResetEmployeeCookieParameters,
            OperationError<ResetEmployeeCookieError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ResetEmployeeCookieSchema,
            ResetEmployeeCookieBody,
            ResetEmployeeCookieData,
            ResetEmployeeCookieParameters,
            OperationError<ResetEmployeeCookieError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Reset Employee Cookie
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const resetEmployeeCookiePendingMutationVariables = qraft.employeesService.resetEmployeeCookie.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const resetEmployeeCookieMutationData = qraft.employeesService.resetEmployeeCookie.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        ResetEmployeeCookieData,
        OperationError<ResetEmployeeCookieError>,
        MutationVariables<ResetEmployeeCookieBody, ResetEmployeeCookieParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            ResetEmployeeCookieBody,
            ResetEmployeeCookieData,
            ResetEmployeeCookieParameters,
            OperationError<ResetEmployeeCookieError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ResetEmployeeCookieSchema,
            ResetEmployeeCookieBody,
            ResetEmployeeCookieData,
            ResetEmployeeCookieParameters,
            OperationError<ResetEmployeeCookieError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          ResetEmployeeCookieData,
          OperationError<ResetEmployeeCookieError>,
          MutationVariables<ResetEmployeeCookieBody, ResetEmployeeCookieParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Reset Employee Cookie */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            ResetEmployeeCookieBody,
            ResetEmployeeCookieData,
            ResetEmployeeCookieParameters,
            OperationError<ResetEmployeeCookieError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ResetEmployeeCookieSchema,
            ResetEmployeeCookieBody,
            ResetEmployeeCookieData,
            ResetEmployeeCookieParameters,
            OperationError<ResetEmployeeCookieError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Reset Employee Cookie
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeesService.resetEmployeeCookie.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeesService.resetEmployeeCookie.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              ResetEmployeeCookieBody,
              ResetEmployeeCookieData,
              ResetEmployeeCookieParameters,
              OperationError<ResetEmployeeCookieError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ResetEmployeeCookieSchema,
              ResetEmployeeCookieBody,
              ResetEmployeeCookieData,
              ResetEmployeeCookieParameters,
              OperationError<ResetEmployeeCookieError>,
              TContext
            >
      ):
        | Mutation<
            ResetEmployeeCookieData,
            ResetEmployeeCookieError,
            MutationVariables<ResetEmployeeCookieBody, ResetEmployeeCookieParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              ResetEmployeeCookieBody,
              ResetEmployeeCookieData,
              ResetEmployeeCookieParameters,
              OperationError<ResetEmployeeCookieError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ResetEmployeeCookieSchema,
              ResetEmployeeCookieBody,
              ResetEmployeeCookieData,
              ResetEmployeeCookieParameters,
              OperationError<ResetEmployeeCookieError>,
              TContext
            >
      ): Array<
        Mutation<
          ResetEmployeeCookieData,
          ResetEmployeeCookieError,
          MutationVariables<ResetEmployeeCookieBody, ResetEmployeeCookieParameters>,
          TContext
        >
      >;
    };
    schema: ResetEmployeeCookieSchema;
    types: {
      parameters: ResetEmployeeCookieParameters;
      data: ResetEmployeeCookieData;
      error: ResetEmployeeCookieError;
      body: ResetEmployeeCookieBody;
    };
  };
  /**
   * @summary Check Extension
   * @description SOL-2636. Live conflict-detection probe for the admin form.
   *
   * Returns the current owner of the extension (if any) within the
   * authenticated office. `office_id` query param is honoured only for
   * super-admins switching offices; regular admins are pinned to their
   * own office.
   */
  checkExtension: {
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<CheckExtensionSchema, CheckExtensionParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<CheckExtensionParameters, TMeta, TSignal>,
      client?: (
        schema: CheckExtensionSchema,
        options: {
          parameters: CheckExtensionParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<CheckExtensionData, CheckExtensionError>>
    ): Promise<RequestFnResponse<CheckExtensionData, CheckExtensionError>>;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    getQueryKey(
      parameters: DeepReadonly<CheckExtensionParameters>
    ): ServiceOperationQueryKey<CheckExtensionSchema, CheckExtensionParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.checkExtension.useQuery({
     *     query: {
     *         extension: extension
     *     }
     * })
     * ```
     */
    useQuery<TData = CheckExtensionData>(
      parameters:
        | ServiceOperationQueryKey<CheckExtensionSchema, CheckExtensionParameters>
        | DeepReadonly<CheckExtensionParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          CheckExtensionData,
          CheckExtensionError,
          TData,
          ServiceOperationQueryKey<CheckExtensionSchema, CheckExtensionParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<CheckExtensionError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.checkExtension.useQuery({
     *     query: {
     *         extension: extension
     *     }
     * })
     * ```
     */
    useQuery<TData = CheckExtensionData>(
      parameters:
        | ServiceOperationQueryKey<CheckExtensionSchema, CheckExtensionParameters>
        | DeepReadonly<CheckExtensionParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          CheckExtensionData,
          CheckExtensionError,
          TData,
          ServiceOperationQueryKey<CheckExtensionSchema, CheckExtensionParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<CheckExtensionError>>;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<CheckExtensionParameters>
    ): ServiceOperationInfiniteQueryKey<CheckExtensionSchema, CheckExtensionParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.checkExtension.useInfiniteQuery({
     *     query: {
     *         extension: extension
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             extension: initialExtension
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends CheckExtensionParameters,
      TQueryFnData = CheckExtensionData,
      TData = OperationInfiniteData<TQueryFnData, CheckExtensionParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<CheckExtensionSchema, CheckExtensionParameters>
        | DeepReadonly<CheckExtensionParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          CheckExtensionError,
          TData,
          ServiceOperationInfiniteQueryKey<CheckExtensionSchema, CheckExtensionParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<CheckExtensionError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.checkExtension.useInfiniteQuery({
     *     query: {
     *         extension: extension
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             extension: initialExtension
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends CheckExtensionParameters,
      TQueryFnData = CheckExtensionData,
      TData = OperationInfiniteData<TQueryFnData, CheckExtensionParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<CheckExtensionSchema, CheckExtensionParameters>
        | DeepReadonly<CheckExtensionParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          CheckExtensionError,
          TData,
          ServiceOperationInfiniteQueryKey<CheckExtensionSchema, CheckExtensionParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<CheckExtensionData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<CheckExtensionError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const checkExtensionTotal = qraft.employeesService.checkExtension.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const checkExtensionByParametersTotal = qraft.employeesService.checkExtension.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             extension: extension
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CheckExtensionSchema,
            CheckExtensionData,
            TInfinite,
            CheckExtensionParameters,
            CheckExtensionError
          >
        | QueryFiltersByQueryKey<
            CheckExtensionSchema,
            CheckExtensionData,
            TInfinite,
            CheckExtensionParameters,
            CheckExtensionError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const checkExtensionResults = qraft.employeesService.checkExtension.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 extension: extension1
     *             }
     *         },
     *         {
     *             query: {
     *                 extension: extension2
     *             }
     *         }
     *     ]
     * });
     * checkExtensionResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const checkExtensionCombinedResults = qraft.employeesService.checkExtension.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 extension: extension1
     *             }
     *         },
     *         {
     *             query: {
     *                 extension: extension2
     *             }
     *         }
     *     ]
     * });
     * checkExtensionCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          CheckExtensionSchema,
          CheckExtensionParameters,
          CheckExtensionData,
          CheckExtensionError
        >
      >,
      TCombinedResult = Array<UseQueryResult<CheckExtensionData, CheckExtensionError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<CheckExtensionData, CheckExtensionError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.employeesService.checkExtension.useSuspenseQuery({
     *     query: {
     *         extension: extension
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = CheckExtensionData>(
      parameters:
        | ServiceOperationQueryKey<CheckExtensionSchema, CheckExtensionParameters>
        | DeepReadonly<CheckExtensionParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          CheckExtensionData,
          CheckExtensionError,
          TData,
          ServiceOperationQueryKey<CheckExtensionSchema, CheckExtensionParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<CheckExtensionError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.checkExtension.useSuspenseInfiniteQuery({
     *     query: {
     *         extension: extension
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             extension: initialExtension
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends CheckExtensionParameters, TData = CheckExtensionData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<CheckExtensionSchema, CheckExtensionParameters>
        | DeepReadonly<CheckExtensionParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          CheckExtensionData,
          CheckExtensionError,
          OperationInfiniteData<TData, CheckExtensionParameters>,
          ServiceOperationInfiniteQueryKey<CheckExtensionSchema, CheckExtensionParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<CheckExtensionData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, CheckExtensionParameters>,
      OperationError<CheckExtensionError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const checkExtensionData = qraft.employeesService.checkExtension.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 extension: extension1
     *             }
     *         },
     *         {
     *             query: {
     *                 extension: extension2
     *             }
     *         }
     *     ]
     * });
     * checkExtensionResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const checkExtensionCombinedData = qraft.employeesService.checkExtension.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 extension: extension1
     *             }
     *         },
     *         {
     *             query: {
     *                 extension: extension2
     *             }
     *         }
     *     ]
     * });
     * checkExtensionCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          CheckExtensionSchema,
          CheckExtensionParameters,
          CheckExtensionData,
          CheckExtensionError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<CheckExtensionData, CheckExtensionError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<CheckExtensionData, CheckExtensionError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        CheckExtensionSchema,
        CheckExtensionData,
        CheckExtensionParameters,
        CheckExtensionError
      >
    ): Promise<CheckExtensionData>;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        CheckExtensionSchema,
        CheckExtensionData,
        CheckExtensionParameters,
        CheckExtensionError
      >
    ): Promise<void>;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        CheckExtensionSchema,
        CheckExtensionData,
        CheckExtensionParameters,
        CheckExtensionError
      >
    ): Promise<CheckExtensionData>;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    fetchInfiniteQuery<TPageParam extends CheckExtensionParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        CheckExtensionSchema,
        CheckExtensionData,
        CheckExtensionParameters,
        DeepReadonly<TPageParam>,
        CheckExtensionError
      >
    ): Promise<OperationInfiniteData<CheckExtensionData, CheckExtensionParameters>>;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    prefetchInfiniteQuery<TPageParam extends CheckExtensionParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        CheckExtensionSchema,
        CheckExtensionData,
        CheckExtensionParameters,
        DeepReadonly<TPageParam>,
        CheckExtensionError
      >
    ): Promise<void>;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    ensureInfiniteQueryData<TPageParam extends CheckExtensionParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        CheckExtensionSchema,
        CheckExtensionData,
        CheckExtensionParameters,
        DeepReadonly<TPageParam>,
        CheckExtensionError
      >
    ): Promise<OperationInfiniteData<CheckExtensionData, CheckExtensionParameters>>;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<CheckExtensionSchema, CheckExtensionParameters>
        | DeepReadonly<CheckExtensionParameters>
    ): CheckExtensionData | undefined;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<CheckExtensionSchema, CheckExtensionParameters>
        | DeepReadonly<CheckExtensionParameters>
    ): OperationInfiniteData<CheckExtensionData, CheckExtensionParameters> | undefined;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CheckExtensionSchema,
            CheckExtensionData,
            TInfinite,
            CheckExtensionParameters,
            CheckExtensionError
          >
        | QueryFiltersByQueryKey<
            CheckExtensionSchema,
            CheckExtensionData,
            TInfinite,
            CheckExtensionParameters,
            CheckExtensionError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<CheckExtensionSchema, CheckExtensionParameters>,
            data: NoInfer<OperationInfiniteData<CheckExtensionData, CheckExtensionParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<CheckExtensionSchema, CheckExtensionParameters>,
            data: CheckExtensionData | undefined,
          ]
        >;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<CheckExtensionSchema, CheckExtensionParameters>
        | DeepReadonly<CheckExtensionParameters>
    ): QueryState<CheckExtensionData, CheckExtensionError> | undefined;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<CheckExtensionParameters>
        | ServiceOperationInfiniteQueryKey<CheckExtensionSchema, CheckExtensionParameters>
    ): QueryState<OperationInfiniteData<CheckExtensionData, CheckExtensionParameters>, CheckExtensionError> | undefined;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    setQueryData(
      parameters:
        | DeepReadonly<CheckExtensionParameters>
        | ServiceOperationQueryKey<CheckExtensionSchema, CheckExtensionParameters>,
      updater: Updater<NoInfer<CheckExtensionData> | undefined, NoInfer<DeepReadonly<CheckExtensionData>> | undefined>,
      options?: SetDataOptions
    ): CheckExtensionData | undefined;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<CheckExtensionParameters>
        | ServiceOperationInfiniteQueryKey<CheckExtensionSchema, CheckExtensionParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<CheckExtensionData, CheckExtensionParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<CheckExtensionData, CheckExtensionParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<CheckExtensionData, CheckExtensionParameters> | undefined;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            CheckExtensionSchema,
            CheckExtensionData,
            TInfinite,
            CheckExtensionParameters,
            CheckExtensionError
          >
        | QueryFiltersByQueryKey<
            CheckExtensionSchema,
            CheckExtensionData,
            TInfinite,
            CheckExtensionParameters,
            CheckExtensionError
          >,
      updater: Updater<NoInfer<CheckExtensionData> | undefined, NoInfer<CheckExtensionData> | undefined>,
      options?: SetDataOptions
    ): Array<CheckExtensionData | undefined>;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        CheckExtensionSchema,
        CheckExtensionData,
        TInfinite,
        CheckExtensionParameters,
        CheckExtensionError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CheckExtensionSchema,
            CheckExtensionData,
            TInfinite,
            CheckExtensionParameters,
            CheckExtensionError
          >
        | QueryFiltersByQueryKey<
            CheckExtensionSchema,
            CheckExtensionData,
            TInfinite,
            CheckExtensionParameters,
            CheckExtensionError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CheckExtensionSchema,
            CheckExtensionData,
            TInfinite,
            CheckExtensionParameters,
            CheckExtensionError
          >
        | QueryFiltersByQueryKey<
            CheckExtensionSchema,
            CheckExtensionData,
            TInfinite,
            CheckExtensionParameters,
            CheckExtensionError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CheckExtensionSchema,
            CheckExtensionData,
            TInfinite,
            CheckExtensionParameters,
            CheckExtensionError
          >
        | QueryFiltersByQueryKey<
            CheckExtensionSchema,
            CheckExtensionData,
            TInfinite,
            CheckExtensionParameters,
            CheckExtensionError
          >
    ): void;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CheckExtensionSchema,
            CheckExtensionData,
            TInfinite,
            CheckExtensionParameters,
            CheckExtensionError
          >
        | QueryFiltersByQueryKey<
            CheckExtensionSchema,
            CheckExtensionData,
            TInfinite,
            CheckExtensionParameters,
            CheckExtensionError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Check Extension
     * @description SOL-2636. Live conflict-detection probe for the admin form.
     *
     * Returns the current owner of the extension (if any) within the
     * authenticated office. `office_id` query param is honoured only for
     * super-admins switching offices; regular admins are pinned to their
     * own office.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CheckExtensionSchema,
            CheckExtensionData,
            TInfinite,
            CheckExtensionParameters,
            CheckExtensionError
          >
        | QueryFiltersByQueryKey<
            CheckExtensionSchema,
            CheckExtensionData,
            TInfinite,
            CheckExtensionParameters,
            CheckExtensionError
          >
    ): number;
    schema: CheckExtensionSchema;
    types: {
      parameters: CheckExtensionParameters;
      data: CheckExtensionData;
      error: CheckExtensionError;
    };
  };
  /**
   * @summary Cascade Extension Attribution Count
   * @description SOL-2636. Count of historic NULL-employee calls that would be
   * re-attributed if `claim_extension` ran for (employee, extension).
   * Drives the live counter under the extensions field.
   */
  cascadeExtensionAttributionCount: {
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<CascadeExtensionAttributionCountParameters, TMeta, TSignal>,
      client?: (
        schema: CascadeExtensionAttributionCountSchema,
        options: {
          parameters: CascadeExtensionAttributionCountParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<CascadeExtensionAttributionCountData, CascadeExtensionAttributionCountError>>
    ): Promise<RequestFnResponse<CascadeExtensionAttributionCountData, CascadeExtensionAttributionCountError>>;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    getQueryKey(
      parameters: DeepReadonly<CascadeExtensionAttributionCountParameters>
    ): ServiceOperationQueryKey<CascadeExtensionAttributionCountSchema, CascadeExtensionAttributionCountParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.cascadeExtensionAttributionCount.useQuery({
     *     path: {
     *         employee_id: employeeId
     *     },
     *     query: {
     *         extension: extension
     *     }
     * })
     * ```
     */
    useQuery<TData = CascadeExtensionAttributionCountData>(
      parameters:
        | ServiceOperationQueryKey<CascadeExtensionAttributionCountSchema, CascadeExtensionAttributionCountParameters>
        | DeepReadonly<CascadeExtensionAttributionCountParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          CascadeExtensionAttributionCountData,
          CascadeExtensionAttributionCountError,
          TData,
          ServiceOperationQueryKey<CascadeExtensionAttributionCountSchema, CascadeExtensionAttributionCountParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<CascadeExtensionAttributionCountError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.cascadeExtensionAttributionCount.useQuery({
     *     path: {
     *         employee_id: employeeId
     *     },
     *     query: {
     *         extension: extension
     *     }
     * })
     * ```
     */
    useQuery<TData = CascadeExtensionAttributionCountData>(
      parameters:
        | ServiceOperationQueryKey<CascadeExtensionAttributionCountSchema, CascadeExtensionAttributionCountParameters>
        | DeepReadonly<CascadeExtensionAttributionCountParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          CascadeExtensionAttributionCountData,
          CascadeExtensionAttributionCountError,
          TData,
          ServiceOperationQueryKey<CascadeExtensionAttributionCountSchema, CascadeExtensionAttributionCountParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<CascadeExtensionAttributionCountError>>;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<CascadeExtensionAttributionCountParameters>
    ): ServiceOperationInfiniteQueryKey<
      CascadeExtensionAttributionCountSchema,
      CascadeExtensionAttributionCountParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.cascadeExtensionAttributionCount.useInfiniteQuery({
     *     path: {
     *         employee_id: employeeId
     *     },
     *     query: {
     *         extension: extension
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             extension: initialExtension
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends CascadeExtensionAttributionCountParameters,
      TQueryFnData = CascadeExtensionAttributionCountData,
      TData = OperationInfiniteData<TQueryFnData, CascadeExtensionAttributionCountParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountParameters
          >
        | DeepReadonly<CascadeExtensionAttributionCountParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          CascadeExtensionAttributionCountError,
          TData,
          ServiceOperationInfiniteQueryKey<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<CascadeExtensionAttributionCountError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.cascadeExtensionAttributionCount.useInfiniteQuery({
     *     path: {
     *         employee_id: employeeId
     *     },
     *     query: {
     *         extension: extension
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             extension: initialExtension
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends CascadeExtensionAttributionCountParameters,
      TQueryFnData = CascadeExtensionAttributionCountData,
      TData = OperationInfiniteData<TQueryFnData, CascadeExtensionAttributionCountParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountParameters
          >
        | DeepReadonly<CascadeExtensionAttributionCountParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          CascadeExtensionAttributionCountError,
          TData,
          ServiceOperationInfiniteQueryKey<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          CascadeExtensionAttributionCountData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<CascadeExtensionAttributionCountError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const cascadeExtensionAttributionCountTotal = qraft.employeesService.cascadeExtensionAttributionCount.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const cascadeExtensionAttributionCountByParametersTotal = qraft.employeesService.cascadeExtensionAttributionCount.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             employee_id: employeeId
     *         },
     *         query: {
     *             extension: extension
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountData,
            TInfinite,
            CascadeExtensionAttributionCountParameters,
            CascadeExtensionAttributionCountError
          >
        | QueryFiltersByQueryKey<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountData,
            TInfinite,
            CascadeExtensionAttributionCountParameters,
            CascadeExtensionAttributionCountError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const cascadeExtensionAttributionCountResults = qraft.employeesService.cascadeExtensionAttributionCount.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 employee_id: employeeId1
     *             },
     *             query: {
     *                 extension: extension1
     *             }
     *         },
     *         {
     *             path: {
     *                 employee_id: employeeId2
     *             },
     *             query: {
     *                 extension: extension2
     *             }
     *         }
     *     ]
     * });
     * cascadeExtensionAttributionCountResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const cascadeExtensionAttributionCountCombinedResults = qraft.employeesService.cascadeExtensionAttributionCount.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 employee_id: employeeId1
     *             },
     *             query: {
     *                 extension: extension1
     *             }
     *         },
     *         {
     *             path: {
     *                 employee_id: employeeId2
     *             },
     *             query: {
     *                 extension: extension2
     *             }
     *         }
     *     ]
     * });
     * cascadeExtensionAttributionCountCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          CascadeExtensionAttributionCountSchema,
          CascadeExtensionAttributionCountParameters,
          CascadeExtensionAttributionCountData,
          CascadeExtensionAttributionCountError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<CascadeExtensionAttributionCountData, CascadeExtensionAttributionCountError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<CascadeExtensionAttributionCountData, CascadeExtensionAttributionCountError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.employeesService.cascadeExtensionAttributionCount.useSuspenseQuery({
     *     path: {
     *         employee_id: employeeId
     *     },
     *     query: {
     *         extension: extension
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = CascadeExtensionAttributionCountData>(
      parameters:
        | ServiceOperationQueryKey<CascadeExtensionAttributionCountSchema, CascadeExtensionAttributionCountParameters>
        | DeepReadonly<CascadeExtensionAttributionCountParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          CascadeExtensionAttributionCountData,
          CascadeExtensionAttributionCountError,
          TData,
          ServiceOperationQueryKey<CascadeExtensionAttributionCountSchema, CascadeExtensionAttributionCountParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<CascadeExtensionAttributionCountError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.cascadeExtensionAttributionCount.useSuspenseInfiniteQuery({
     *     path: {
     *         employee_id: employeeId
     *     },
     *     query: {
     *         extension: extension
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             extension: initialExtension
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends CascadeExtensionAttributionCountParameters,
      TData = CascadeExtensionAttributionCountData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountParameters
          >
        | DeepReadonly<CascadeExtensionAttributionCountParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          CascadeExtensionAttributionCountData,
          CascadeExtensionAttributionCountError,
          OperationInfiniteData<TData, CascadeExtensionAttributionCountParameters>,
          ServiceOperationInfiniteQueryKey<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          CascadeExtensionAttributionCountData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, CascadeExtensionAttributionCountParameters>,
      OperationError<CascadeExtensionAttributionCountError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const cascadeExtensionAttributionCountData = qraft.employeesService.cascadeExtensionAttributionCount.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 employee_id: employeeId1
     *             },
     *             query: {
     *                 extension: extension1
     *             }
     *         },
     *         {
     *             path: {
     *                 employee_id: employeeId2
     *             },
     *             query: {
     *                 extension: extension2
     *             }
     *         }
     *     ]
     * });
     * cascadeExtensionAttributionCountResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const cascadeExtensionAttributionCountCombinedData = qraft.employeesService.cascadeExtensionAttributionCount.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 employee_id: employeeId1
     *             },
     *             query: {
     *                 extension: extension1
     *             }
     *         },
     *         {
     *             path: {
     *                 employee_id: employeeId2
     *             },
     *             query: {
     *                 extension: extension2
     *             }
     *         }
     *     ]
     * });
     * cascadeExtensionAttributionCountCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          CascadeExtensionAttributionCountSchema,
          CascadeExtensionAttributionCountParameters,
          CascadeExtensionAttributionCountData,
          CascadeExtensionAttributionCountError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<CascadeExtensionAttributionCountData, CascadeExtensionAttributionCountError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<CascadeExtensionAttributionCountData, CascadeExtensionAttributionCountError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        CascadeExtensionAttributionCountSchema,
        CascadeExtensionAttributionCountData,
        CascadeExtensionAttributionCountParameters,
        CascadeExtensionAttributionCountError
      >
    ): Promise<CascadeExtensionAttributionCountData>;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        CascadeExtensionAttributionCountSchema,
        CascadeExtensionAttributionCountData,
        CascadeExtensionAttributionCountParameters,
        CascadeExtensionAttributionCountError
      >
    ): Promise<void>;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        CascadeExtensionAttributionCountSchema,
        CascadeExtensionAttributionCountData,
        CascadeExtensionAttributionCountParameters,
        CascadeExtensionAttributionCountError
      >
    ): Promise<CascadeExtensionAttributionCountData>;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    fetchInfiniteQuery<TPageParam extends CascadeExtensionAttributionCountParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        CascadeExtensionAttributionCountSchema,
        CascadeExtensionAttributionCountData,
        CascadeExtensionAttributionCountParameters,
        DeepReadonly<TPageParam>,
        CascadeExtensionAttributionCountError
      >
    ): Promise<OperationInfiniteData<CascadeExtensionAttributionCountData, CascadeExtensionAttributionCountParameters>>;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    prefetchInfiniteQuery<TPageParam extends CascadeExtensionAttributionCountParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        CascadeExtensionAttributionCountSchema,
        CascadeExtensionAttributionCountData,
        CascadeExtensionAttributionCountParameters,
        DeepReadonly<TPageParam>,
        CascadeExtensionAttributionCountError
      >
    ): Promise<void>;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    ensureInfiniteQueryData<TPageParam extends CascadeExtensionAttributionCountParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        CascadeExtensionAttributionCountSchema,
        CascadeExtensionAttributionCountData,
        CascadeExtensionAttributionCountParameters,
        DeepReadonly<TPageParam>,
        CascadeExtensionAttributionCountError
      >
    ): Promise<OperationInfiniteData<CascadeExtensionAttributionCountData, CascadeExtensionAttributionCountParameters>>;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<CascadeExtensionAttributionCountSchema, CascadeExtensionAttributionCountParameters>
        | DeepReadonly<CascadeExtensionAttributionCountParameters>
    ): CascadeExtensionAttributionCountData | undefined;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountParameters
          >
        | DeepReadonly<CascadeExtensionAttributionCountParameters>
    ):
      | OperationInfiniteData<CascadeExtensionAttributionCountData, CascadeExtensionAttributionCountParameters>
      | undefined;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountData,
            TInfinite,
            CascadeExtensionAttributionCountParameters,
            CascadeExtensionAttributionCountError
          >
        | QueryFiltersByQueryKey<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountData,
            TInfinite,
            CascadeExtensionAttributionCountParameters,
            CascadeExtensionAttributionCountError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              CascadeExtensionAttributionCountSchema,
              CascadeExtensionAttributionCountParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    CascadeExtensionAttributionCountData,
                    CascadeExtensionAttributionCountParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              CascadeExtensionAttributionCountSchema,
              CascadeExtensionAttributionCountParameters
            >,
            data: CascadeExtensionAttributionCountData | undefined,
          ]
        >;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<CascadeExtensionAttributionCountSchema, CascadeExtensionAttributionCountParameters>
        | DeepReadonly<CascadeExtensionAttributionCountParameters>
    ): QueryState<CascadeExtensionAttributionCountData, CascadeExtensionAttributionCountError> | undefined;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<CascadeExtensionAttributionCountParameters>
        | ServiceOperationInfiniteQueryKey<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<CascadeExtensionAttributionCountData, CascadeExtensionAttributionCountParameters>,
          CascadeExtensionAttributionCountError
        >
      | undefined;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    setQueryData(
      parameters:
        | DeepReadonly<CascadeExtensionAttributionCountParameters>
        | ServiceOperationQueryKey<CascadeExtensionAttributionCountSchema, CascadeExtensionAttributionCountParameters>,
      updater: Updater<
        NoInfer<CascadeExtensionAttributionCountData> | undefined,
        NoInfer<DeepReadonly<CascadeExtensionAttributionCountData>> | undefined
      >,
      options?: SetDataOptions
    ): CascadeExtensionAttributionCountData | undefined;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<CascadeExtensionAttributionCountParameters>
        | ServiceOperationInfiniteQueryKey<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<CascadeExtensionAttributionCountData, CascadeExtensionAttributionCountParameters>
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<CascadeExtensionAttributionCountData, CascadeExtensionAttributionCountParameters>
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<CascadeExtensionAttributionCountData, CascadeExtensionAttributionCountParameters>
      | undefined;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountData,
            TInfinite,
            CascadeExtensionAttributionCountParameters,
            CascadeExtensionAttributionCountError
          >
        | QueryFiltersByQueryKey<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountData,
            TInfinite,
            CascadeExtensionAttributionCountParameters,
            CascadeExtensionAttributionCountError
          >,
      updater: Updater<
        NoInfer<CascadeExtensionAttributionCountData> | undefined,
        NoInfer<CascadeExtensionAttributionCountData> | undefined
      >,
      options?: SetDataOptions
    ): Array<CascadeExtensionAttributionCountData | undefined>;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        CascadeExtensionAttributionCountSchema,
        CascadeExtensionAttributionCountData,
        TInfinite,
        CascadeExtensionAttributionCountParameters,
        CascadeExtensionAttributionCountError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountData,
            TInfinite,
            CascadeExtensionAttributionCountParameters,
            CascadeExtensionAttributionCountError
          >
        | QueryFiltersByQueryKey<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountData,
            TInfinite,
            CascadeExtensionAttributionCountParameters,
            CascadeExtensionAttributionCountError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountData,
            TInfinite,
            CascadeExtensionAttributionCountParameters,
            CascadeExtensionAttributionCountError
          >
        | QueryFiltersByQueryKey<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountData,
            TInfinite,
            CascadeExtensionAttributionCountParameters,
            CascadeExtensionAttributionCountError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountData,
            TInfinite,
            CascadeExtensionAttributionCountParameters,
            CascadeExtensionAttributionCountError
          >
        | QueryFiltersByQueryKey<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountData,
            TInfinite,
            CascadeExtensionAttributionCountParameters,
            CascadeExtensionAttributionCountError
          >
    ): void;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountData,
            TInfinite,
            CascadeExtensionAttributionCountParameters,
            CascadeExtensionAttributionCountError
          >
        | QueryFiltersByQueryKey<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountData,
            TInfinite,
            CascadeExtensionAttributionCountParameters,
            CascadeExtensionAttributionCountError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Cascade Extension Attribution Count
     * @description SOL-2636. Count of historic NULL-employee calls that would be
     * re-attributed if `claim_extension` ran for (employee, extension).
     * Drives the live counter under the extensions field.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountData,
            TInfinite,
            CascadeExtensionAttributionCountParameters,
            CascadeExtensionAttributionCountError
          >
        | QueryFiltersByQueryKey<
            CascadeExtensionAttributionCountSchema,
            CascadeExtensionAttributionCountData,
            TInfinite,
            CascadeExtensionAttributionCountParameters,
            CascadeExtensionAttributionCountError
          >
    ): number;
    schema: CascadeExtensionAttributionCountSchema;
    types: {
      parameters: CascadeExtensionAttributionCountParameters;
      data: CascadeExtensionAttributionCountData;
      error: CascadeExtensionAttributionCountError;
    };
  };
  /**
   * @summary Claim Extension
   * @description SOL-2636. Atomic Move endpoint replacing the original split
   * cascade flow. Resolves office from the target employee (never from
   * the request body), guards with a per-(office, extension) advisory
   * lock, removes the extension from any prior owner, appends to the
   * target, re-attributes historic NULL-employee calls, and writes a
   * CASCADE audit row per re-attributed call.
   */
  claimExtension: {
    /**
     * @summary Claim Extension
     * @description SOL-2636. Atomic Move endpoint replacing the original split
     * cascade flow. Resolves office from the target employee (never from
     * the request body), guards with a per-(office, extension) advisory
     * lock, removes the extension from any prior owner, appends to the
     * target, re-attributes historic NULL-employee calls, and writes a
     * CASCADE audit row per re-attributed call.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<ClaimExtensionBody, ClaimExtensionParameters, TMeta, TSignal>,
      client?: (
        schema: ClaimExtensionSchema,
        options: ServiceOperationMutationFnOptions<ClaimExtensionBody, ClaimExtensionParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<ClaimExtensionData, ClaimExtensionError>>
    ): Promise<RequestFnResponse<ClaimExtensionData, ClaimExtensionError>>;
    /**
     * @summary Claim Extension
     * @description SOL-2636. Atomic Move endpoint replacing the original split
     * cascade flow. Resolves office from the target employee (never from
     * the request body), guards with a per-(office, extension) advisory
     * lock, removes the extension from any prior owner, appends to the
     * target, re-attributes historic NULL-employee calls, and writes a
     * CASCADE audit row per re-attributed call.
     */
    getMutationKey(
      parameters: DeepReadonly<ClaimExtensionParameters> | void
    ): ServiceOperationMutationKey<ClaimExtensionSchema, ClaimExtensionParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Claim Extension
     * @description SOL-2636. Atomic Move endpoint replacing the original split
     * cascade flow. Resolves office from the target employee (never from
     * the request body), guards with a per-(office, extension) advisory
     * lock, removes the extension from any prior owner, appends to the
     * target, re-attributes historic NULL-employee calls, and writes a
     * CASCADE audit row per re-attributed call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.claimExtension.useMutation({
     *     path: {
     *         employee_id: employeeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.claimExtension.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         employee_id: employeeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends ClaimExtensionBody, TContext = unknown>(
      parameters: DeepReadonly<ClaimExtensionParameters>,
      options?: ServiceOperationUseMutationOptions<
        ClaimExtensionSchema,
        ClaimExtensionData,
        ClaimExtensionParameters,
        TVariables,
        OperationError<ClaimExtensionError>,
        TContext
      >
    ): UseMutationResult<ClaimExtensionData, OperationError<ClaimExtensionError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Claim Extension
     * @description SOL-2636. Atomic Move endpoint replacing the original split
     * cascade flow. Resolves office from the target employee (never from
     * the request body), guards with a per-(office, extension) advisory
     * lock, removes the extension from any prior owner, appends to the
     * target, re-attributes historic NULL-employee calls, and writes a
     * CASCADE audit row per re-attributed call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.claimExtension.useMutation({
     *     path: {
     *         employee_id: employeeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.claimExtension.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         employee_id: employeeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends MutationVariables<ClaimExtensionBody, ClaimExtensionParameters>, TContext = unknown>(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        ClaimExtensionSchema,
        ClaimExtensionData,
        ClaimExtensionParameters,
        TVariables,
        OperationError<ClaimExtensionError>,
        TContext
      >
    ): UseMutationResult<ClaimExtensionData, OperationError<ClaimExtensionError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Claim Extension
     * @description SOL-2636. Atomic Move endpoint replacing the original split
     * cascade flow. Resolves office from the target employee (never from
     * the request body), guards with a per-(office, extension) advisory
     * lock, removes the extension from any prior owner, appends to the
     * target, re-attributes historic NULL-employee calls, and writes a
     * CASCADE audit row per re-attributed call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const claimExtensionTotal = qraft.employeesService.claimExtension.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const claimExtensionTotal = qraft.employeesService.claimExtension.useIsMutating({
     *     parameters: {
     *         path: {
     *             employee_id: employeeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            ClaimExtensionBody,
            ClaimExtensionData,
            ClaimExtensionParameters,
            OperationError<ClaimExtensionError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ClaimExtensionSchema,
            ClaimExtensionBody,
            ClaimExtensionData,
            ClaimExtensionParameters,
            OperationError<ClaimExtensionError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Claim Extension
     * @description SOL-2636. Atomic Move endpoint replacing the original split
     * cascade flow. Resolves office from the target employee (never from
     * the request body), guards with a per-(office, extension) advisory
     * lock, removes the extension from any prior owner, appends to the
     * target, re-attributes historic NULL-employee calls, and writes a
     * CASCADE audit row per re-attributed call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const claimExtensionPendingMutationVariables = qraft.employeesService.claimExtension.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const claimExtensionMutationData = qraft.employeesService.claimExtension.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 employee_id: employeeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        ClaimExtensionData,
        OperationError<ClaimExtensionError>,
        MutationVariables<ClaimExtensionBody, ClaimExtensionParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            ClaimExtensionBody,
            ClaimExtensionData,
            ClaimExtensionParameters,
            OperationError<ClaimExtensionError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ClaimExtensionSchema,
            ClaimExtensionBody,
            ClaimExtensionData,
            ClaimExtensionParameters,
            OperationError<ClaimExtensionError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          ClaimExtensionData,
          OperationError<ClaimExtensionError>,
          MutationVariables<ClaimExtensionBody, ClaimExtensionParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Claim Extension
     * @description SOL-2636. Atomic Move endpoint replacing the original split
     * cascade flow. Resolves office from the target employee (never from
     * the request body), guards with a per-(office, extension) advisory
     * lock, removes the extension from any prior owner, appends to the
     * target, re-attributes historic NULL-employee calls, and writes a
     * CASCADE audit row per re-attributed call.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            ClaimExtensionBody,
            ClaimExtensionData,
            ClaimExtensionParameters,
            OperationError<ClaimExtensionError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ClaimExtensionSchema,
            ClaimExtensionBody,
            ClaimExtensionData,
            ClaimExtensionParameters,
            OperationError<ClaimExtensionError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Claim Extension
     * @description SOL-2636. Atomic Move endpoint replacing the original split
     * cascade flow. Resolves office from the target employee (never from
     * the request body), guards with a per-(office, extension) advisory
     * lock, removes the extension from any prior owner, appends to the
     * target, re-attributes historic NULL-employee calls, and writes a
     * CASCADE audit row per re-attributed call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeesService.claimExtension.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             employee_id: employeeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeesService.claimExtension.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              ClaimExtensionBody,
              ClaimExtensionData,
              ClaimExtensionParameters,
              OperationError<ClaimExtensionError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ClaimExtensionSchema,
              ClaimExtensionBody,
              ClaimExtensionData,
              ClaimExtensionParameters,
              OperationError<ClaimExtensionError>,
              TContext
            >
      ):
        | Mutation<
            ClaimExtensionData,
            ClaimExtensionError,
            MutationVariables<ClaimExtensionBody, ClaimExtensionParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              ClaimExtensionBody,
              ClaimExtensionData,
              ClaimExtensionParameters,
              OperationError<ClaimExtensionError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ClaimExtensionSchema,
              ClaimExtensionBody,
              ClaimExtensionData,
              ClaimExtensionParameters,
              OperationError<ClaimExtensionError>,
              TContext
            >
      ): Array<
        Mutation<
          ClaimExtensionData,
          ClaimExtensionError,
          MutationVariables<ClaimExtensionBody, ClaimExtensionParameters>,
          TContext
        >
      >;
    };
    schema: ClaimExtensionSchema;
    types: {
      parameters: ClaimExtensionParameters;
      data: ClaimExtensionData;
      error: ClaimExtensionError;
      body: ClaimExtensionBody;
    };
  };
}
/** @summary Me */
export const meEmployeesMeGet = {
  schema: {
    method: 'get',
    url: '/employees/me',
    security: ['HTTPBearer'],
  },
} as {
  schema: MeEmployeesMeGetSchema;
  [QraftServiceOperationsToken]: EmployeesService['meEmployeesMeGet'];
};
/** @summary Me Options */
export const meOptions = {
  schema: {
    method: 'get',
    url: '/employees/me/options',
    security: ['HTTPBearer'],
  },
} as {
  schema: MeOptionsSchema;
  [QraftServiceOperationsToken]: EmployeesService['meOptions'];
};
/** @summary Get All */
export const getAllEmployeesGet = {
  schema: {
    method: 'get',
    url: '/employees/',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAllEmployeesGetSchema;
  [QraftServiceOperationsToken]: EmployeesService['getAllEmployeesGet'];
};
/** @summary Create */
export const createEmployeesPost = {
  schema: {
    method: 'post',
    url: '/employees/',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateEmployeesPostSchema;
  [QraftServiceOperationsToken]: EmployeesService['createEmployeesPost'];
};
/**
 * @summary Search Employees
 * @description Search employees with pagination and optional filters.
 */
export const searchEmployees = {
  schema: {
    method: 'get',
    url: '/employees/search',
    security: ['HTTPBearer'],
  },
} as {
  schema: SearchEmployeesSchema;
  [QraftServiceOperationsToken]: EmployeesService['searchEmployees'];
};
/** @summary Batch Update Employees */
export const batchUpdateEmployees = {
  schema: {
    method: 'post',
    url: '/employees/batch/update',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: BatchUpdateEmployeesSchema;
  [QraftServiceOperationsToken]: EmployeesService['batchUpdateEmployees'];
};
/** @summary Update */
export const updateEmployeesEmployeeIdPut = {
  schema: {
    method: 'put',
    url: '/employees/{employee_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateEmployeesEmployeeIdPutSchema;
  [QraftServiceOperationsToken]: EmployeesService['updateEmployeesEmployeeIdPut'];
};
/** @summary Upload File */
export const uploadFileEmployeesEmployeeIdFilesPost = {
  schema: {
    method: 'post',
    url: '/employees/{employee_id}/files',
    mediaType: ['multipart/form-data'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UploadFileEmployeesEmployeeIdFilesPostSchema;
  [QraftServiceOperationsToken]: EmployeesService['uploadFileEmployeesEmployeeIdFilesPost'];
};
/** @summary Get Employee Worklogs */
export const getEmployeeWorklogsEmployeesEmployeeIdWorklogsGet = {
  schema: {
    method: 'get',
    url: '/employees/{employee_id}/worklogs',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema;
  [QraftServiceOperationsToken]: EmployeesService['getEmployeeWorklogsEmployeesEmployeeIdWorklogsGet'];
};
/** @summary Admin List Employees */
export const adminListEmployees = {
  schema: {
    method: 'get',
    url: '/employees/admin/list',
    security: ['HTTPBearer'],
  },
} as {
  schema: AdminListEmployeesSchema;
  [QraftServiceOperationsToken]: EmployeesService['adminListEmployees'];
};
/** @summary Switch To Employee */
export const switchToEmployee = {
  schema: {
    method: 'post',
    url: '/employees/switch_to_employee',
    security: ['HTTPBearer'],
  },
} as {
  schema: SwitchToEmployeeSchema;
  [QraftServiceOperationsToken]: EmployeesService['switchToEmployee'];
};
/**
 * @deprecated
 * @summary Admin Switch To Employee
 * @description Use /switch_to_employee instead
 */
export const adminSwitchToEmployee = {
  schema: {
    method: 'post',
    url: '/employees/admin/switch_to_employee',
    security: ['HTTPBearer'],
  },
} as {
  schema: AdminSwitchToEmployeeSchema;
  [QraftServiceOperationsToken]: EmployeesService['adminSwitchToEmployee'];
};
/** @summary Switch To Office */
export const switchToOffice = {
  schema: {
    method: 'post',
    url: '/employees/admin/switch_to_office',
    security: ['HTTPBearer'],
  },
} as {
  schema: SwitchToOfficeSchema;
  [QraftServiceOperationsToken]: EmployeesService['switchToOffice'];
};
/** @summary Reset Employee Cookie */
export const resetEmployeeCookie = {
  schema: {
    method: 'post',
    url: '/employees/admin/reset_employee_cookie',
  },
} as {
  schema: ResetEmployeeCookieSchema;
  [QraftServiceOperationsToken]: EmployeesService['resetEmployeeCookie'];
};
/**
 * @summary Check Extension
 * @description SOL-2636. Live conflict-detection probe for the admin form.
 *
 * Returns the current owner of the extension (if any) within the
 * authenticated office. `office_id` query param is honoured only for
 * super-admins switching offices; regular admins are pinned to their
 * own office.
 */
export const checkExtension = {
  schema: {
    method: 'get',
    url: '/employees/check_extension',
    security: ['HTTPBearer'],
  },
} as {
  schema: CheckExtensionSchema;
  [QraftServiceOperationsToken]: EmployeesService['checkExtension'];
};
/**
 * @summary Cascade Extension Attribution Count
 * @description SOL-2636. Count of historic NULL-employee calls that would be
 * re-attributed if `claim_extension` ran for (employee, extension).
 * Drives the live counter under the extensions field.
 */
export const cascadeExtensionAttributionCount = {
  schema: {
    method: 'get',
    url: '/employees/{employee_id}/cascade_extension_attribution/count',
    security: ['HTTPBearer'],
  },
} as {
  schema: CascadeExtensionAttributionCountSchema;
  [QraftServiceOperationsToken]: EmployeesService['cascadeExtensionAttributionCount'];
};
/**
 * @summary Claim Extension
 * @description SOL-2636. Atomic Move endpoint replacing the original split
 * cascade flow. Resolves office from the target employee (never from
 * the request body), guards with a per-(office, extension) advisory
 * lock, removes the extension from any prior owner, appends to the
 * target, re-attributes historic NULL-employee calls, and writes a
 * CASCADE audit row per re-attributed call.
 */
export const claimExtension = {
  schema: {
    method: 'post',
    url: '/employees/{employee_id}/claim_extension',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: ClaimExtensionSchema;
  [QraftServiceOperationsToken]: EmployeesService['claimExtension'];
};
export const employeesService = {
  meEmployeesMeGet,
  meOptions,
  getAllEmployeesGet,
  createEmployeesPost,
  searchEmployees,
  batchUpdateEmployees,
  updateEmployeesEmployeeIdPut,
  uploadFileEmployeesEmployeeIdFilesPost,
  getEmployeeWorklogsEmployeesEmployeeIdWorklogsGet,
  adminListEmployees,
  switchToEmployee,
  adminSwitchToEmployee,
  switchToOffice,
  resetEmployeeCookie,
  checkExtension,
  cascadeExtensionAttributionCount,
  claimExtension,
} as const;
type MeEmployeesMeGetSchema = {
  method: 'get';
  url: '/employees/me';
  security: ['HTTPBearer'];
};
type MeEmployeesMeGetParameters = undefined;
type MeEmployeesMeGetData = paths['/employees/me']['get']['responses']['200']['content']['application/json'];
type MeEmployeesMeGetError = unknown;
type MeOptionsSchema = {
  method: 'get';
  url: '/employees/me/options';
  security: ['HTTPBearer'];
};
type MeOptionsParameters = undefined;
type MeOptionsData = paths['/employees/me/options']['get']['responses']['200']['content']['application/json'];
type MeOptionsError = unknown;
type GetAllEmployeesGetSchema = {
  method: 'get';
  url: '/employees/';
  security: ['HTTPBearer'];
};
type GetAllEmployeesGetParameters = undefined;
type GetAllEmployeesGetData = paths['/employees/']['get']['responses']['200']['content']['application/json'];
type GetAllEmployeesGetError = unknown;
type CreateEmployeesPostSchema = {
  method: 'post';
  url: '/employees/';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateEmployeesPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateEmployeesPostData = paths['/employees/']['post']['responses']['200']['content']['application/json'];
type CreateEmployeesPostError = paths['/employees/']['post']['responses']['422']['content']['application/json'];
type CreateEmployeesPostBody = paths['/employees/']['post']['requestBody']['content']['application/json'];
type SearchEmployeesSchema = {
  method: 'get';
  url: '/employees/search';
  security: ['HTTPBearer'];
};
type SearchEmployeesParameters = paths['/employees/search']['get']['parameters'];
type SearchEmployeesData = paths['/employees/search']['get']['responses']['200']['content']['application/json'];
type SearchEmployeesError = paths['/employees/search']['get']['responses']['422']['content']['application/json'];
type BatchUpdateEmployeesSchema = {
  method: 'post';
  url: '/employees/batch/update';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type BatchUpdateEmployeesParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type BatchUpdateEmployeesData =
  paths['/employees/batch/update']['post']['responses']['200']['content']['application/json'];
type BatchUpdateEmployeesError =
  paths['/employees/batch/update']['post']['responses']['422']['content']['application/json'];
type BatchUpdateEmployeesBody = paths['/employees/batch/update']['post']['requestBody']['content']['application/json'];
type UpdateEmployeesEmployeeIdPutSchema = {
  method: 'put';
  url: '/employees/{employee_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateEmployeesEmployeeIdPutParameters = paths['/employees/{employee_id}']['put']['parameters'];
type UpdateEmployeesEmployeeIdPutData =
  paths['/employees/{employee_id}']['put']['responses']['200']['content']['application/json'];
type UpdateEmployeesEmployeeIdPutError =
  paths['/employees/{employee_id}']['put']['responses']['422']['content']['application/json'];
type UpdateEmployeesEmployeeIdPutBody =
  paths['/employees/{employee_id}']['put']['requestBody']['content']['application/json'];
type UploadFileEmployeesEmployeeIdFilesPostSchema = {
  method: 'post';
  url: '/employees/{employee_id}/files';
  mediaType: ['multipart/form-data'];
  security: ['HTTPBearer'];
};
type UploadFileEmployeesEmployeeIdFilesPostParameters = paths['/employees/{employee_id}/files']['post']['parameters'];
type UploadFileEmployeesEmployeeIdFilesPostData =
  paths['/employees/{employee_id}/files']['post']['responses']['200']['content']['application/json'];
type UploadFileEmployeesEmployeeIdFilesPostError =
  paths['/employees/{employee_id}/files']['post']['responses']['422']['content']['application/json'];
type UploadFileEmployeesEmployeeIdFilesPostBody =
  | paths['/employees/{employee_id}/files']['post']['requestBody']['content']['multipart/form-data']
  | FormData;
type GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetSchema = {
  method: 'get';
  url: '/employees/{employee_id}/worklogs';
  security: ['HTTPBearer'];
};
type GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetParameters =
  paths['/employees/{employee_id}/worklogs']['get']['parameters'];
type GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetData =
  paths['/employees/{employee_id}/worklogs']['get']['responses']['200']['content']['application/json'];
type GetEmployeeWorklogsEmployeesEmployeeIdWorklogsGetError =
  paths['/employees/{employee_id}/worklogs']['get']['responses']['422']['content']['application/json'];
type AdminListEmployeesSchema = {
  method: 'get';
  url: '/employees/admin/list';
  security: ['HTTPBearer'];
};
type AdminListEmployeesParameters = paths['/employees/admin/list']['get']['parameters'];
type AdminListEmployeesData = paths['/employees/admin/list']['get']['responses']['200']['content']['application/json'];
type AdminListEmployeesError = paths['/employees/admin/list']['get']['responses']['422']['content']['application/json'];
type SwitchToEmployeeSchema = {
  method: 'post';
  url: '/employees/switch_to_employee';
  security: ['HTTPBearer'];
};
type SwitchToEmployeeParameters = paths['/employees/switch_to_employee']['post']['parameters'];
type SwitchToEmployeeData =
  paths['/employees/switch_to_employee']['post']['responses']['200']['content']['application/json'];
type SwitchToEmployeeError =
  paths['/employees/switch_to_employee']['post']['responses']['422']['content']['application/json'];
type SwitchToEmployeeBody = undefined;
type AdminSwitchToEmployeeSchema = {
  method: 'post';
  url: '/employees/admin/switch_to_employee';
  security: ['HTTPBearer'];
};
type AdminSwitchToEmployeeParameters = paths['/employees/admin/switch_to_employee']['post']['parameters'];
type AdminSwitchToEmployeeData =
  paths['/employees/admin/switch_to_employee']['post']['responses']['200']['content']['application/json'];
type AdminSwitchToEmployeeError =
  paths['/employees/admin/switch_to_employee']['post']['responses']['422']['content']['application/json'];
type AdminSwitchToEmployeeBody = undefined;
type SwitchToOfficeSchema = {
  method: 'post';
  url: '/employees/admin/switch_to_office';
  security: ['HTTPBearer'];
};
type SwitchToOfficeParameters = paths['/employees/admin/switch_to_office']['post']['parameters'];
type SwitchToOfficeData =
  paths['/employees/admin/switch_to_office']['post']['responses']['200']['content']['application/json'];
type SwitchToOfficeError =
  paths['/employees/admin/switch_to_office']['post']['responses']['422']['content']['application/json'];
type SwitchToOfficeBody = undefined;
type ResetEmployeeCookieSchema = {
  method: 'post';
  url: '/employees/admin/reset_employee_cookie';
};
type ResetEmployeeCookieParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type ResetEmployeeCookieData =
  paths['/employees/admin/reset_employee_cookie']['post']['responses']['200']['content']['application/json'];
type ResetEmployeeCookieError = unknown;
type ResetEmployeeCookieBody = undefined;
type CheckExtensionSchema = {
  method: 'get';
  url: '/employees/check_extension';
  security: ['HTTPBearer'];
};
type CheckExtensionParameters = paths['/employees/check_extension']['get']['parameters'];
type CheckExtensionData = paths['/employees/check_extension']['get']['responses']['200']['content']['application/json'];
type CheckExtensionError =
  paths['/employees/check_extension']['get']['responses']['422']['content']['application/json'];
type CascadeExtensionAttributionCountSchema = {
  method: 'get';
  url: '/employees/{employee_id}/cascade_extension_attribution/count';
  security: ['HTTPBearer'];
};
type CascadeExtensionAttributionCountParameters =
  paths['/employees/{employee_id}/cascade_extension_attribution/count']['get']['parameters'];
type CascadeExtensionAttributionCountData =
  paths['/employees/{employee_id}/cascade_extension_attribution/count']['get']['responses']['200']['content']['application/json'];
type CascadeExtensionAttributionCountError =
  paths['/employees/{employee_id}/cascade_extension_attribution/count']['get']['responses']['422']['content']['application/json'];
type ClaimExtensionSchema = {
  method: 'post';
  url: '/employees/{employee_id}/claim_extension';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type ClaimExtensionParameters = paths['/employees/{employee_id}/claim_extension']['post']['parameters'];
type ClaimExtensionData =
  paths['/employees/{employee_id}/claim_extension']['post']['responses']['200']['content']['application/json'];
type ClaimExtensionError =
  paths['/employees/{employee_id}/claim_extension']['post']['responses']['422']['content']['application/json'];
type ClaimExtensionBody =
  paths['/employees/{employee_id}/claim_extension']['post']['requestBody']['content']['application/json'];
